import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  signal,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewChild,
  ElementRef,
  effect,
  computed,
} from '@angular/core';
declare const L: any;
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import {
  latLng,
  tileLayer,
  Map,
  LatLngExpression,
  TileLayer,
  MapOptions,
  geoJSON,
  GeoJSON,
  LayerGroup,
  FeatureGroup,
  featureGroup,
  DrawEvents,
  Control,
} from 'leaflet';
import 'leaflet-easybutton';
import {
  LeafletDrawDirective,
  LeafletDrawModule,
} from '@bluehalo/ngx-leaflet-draw';
import 'leaflet-splitmap';
import { environment } from '../../../environments/environment';
import { VisorgisService } from '../visorgis/services/visorgis.service';
import { MapaService } from 'src/app/shared/components/mapa/services/mapa.service';
import { TeledeteccionService } from './services/teledeteccion.service';
import {
  TeledeteccionArea,
  AreaGeometry,
} from '../../model/teledeteccion-area.model';
import { TeledeteccionContainerComponent } from './components/teledeteccion-container/teledeteccion-container.component';
import { ChipsMapButtonsComponent } from '../../shared/components/mapa/components/chips-map-buttons/chips-map-buttons.component';
import { ChipsContainerComponent } from '../../shared/components/mapa/components/chips-container/chips-container.component';
import { ModalFormService } from 'src/app/shared/components/modal-form/service/modal-form.service';
import { drawLocalConfig } from '../visorgis/interfaces/drawLocal';
import { Subscription, forkJoin, of, Observable } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  filter,
  mergeMap,
  delay,
  shareReplay,
  finalize,
  tap,
} from 'rxjs/operators';
import { from, toArray } from 'rxjs';
import { ColoredScaleComponent } from './components/colored-scale/colored-scale.component';
import { SelectorDatepickerComponent } from './components/selector-datepicker/selector-datepicker.component';
import {
  SelectorChipComponent,
  SelectorElement,
} from './components/selector-chip/selector-chip.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  COLOR_RAMPS,
  INDEX_TO_RAMP,
  getExpandedRamp,
} from './components/colored-scale/color-ramps';
import { MenuComparacionComponent } from './components/menu-comparacion/menu-comparacion.component';
import {
  INDICE_TOOLTIP_TEXT,
  SELECT_INDICE_VEGETACION,
} from './enums/indices.enum';
import { GpsIndicatorComponent } from '../../shared/components/mapa/components/gps-indicator/gps-indicator.component';
// Nota: GeoRasterLayer se importará dinámicamente para reducir el peso inicial del bundle
import {
  isLeafletMapReady,
  waitForLeafletMapReady,
  ensureLayerGroupHasBase,
  prepareSplitGroups,
  extractDateString,
  extractIndiceValue,
  computeBoundsFromResponse,
  getColorRampForIndexName,
  buildColorFn,
  createGeoRasterLayerFromBase64,
  recomputeAreaStyles as recomputeAreaStylesUtil,
  resolveActiveAreaIdForLegend,
  getEscalaTypeFromForm,
  getScaleRangeFromForm,
} from './utils/utils';
import { DatePipe, NgClass, TitleCasePipe } from '@angular/common';
import { LoadSpinnerComponent } from '../../shared/components/load-spinner/load-spinner.component';
import { ConfiguracionService } from '../configuracion/services/configuracion.service';
import { AuthService } from '../login/services/auth.service';
import { LineChartComponent } from '../../shared/components/ng2-charts-components/line_chart/line.component';
import { ChartData } from 'chart.js';
import { catchError } from 'rxjs/operators';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { BuscadorAutocompleteComponent } from '../../shared/components/buscador-autocomplete/buscador-autocomplete.component';
import { SearchItem } from '../../shared/components/buscador-autocomplete/models/search.interface';
import { TooltipDirective } from '../../shared/directives/tooltip.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CollapsiblePopupShellComponent } from '../../shared/components/collapsible-popup-shell/collapsible-popup-shell.component';

@Component({
  selector: 'app-teledeteccion',
  imports: [
    LeafletModule,
    LeafletDrawModule,
    TeledeteccionContainerComponent,
    ChipsMapButtonsComponent,
    ChipsContainerComponent,
    ColoredScaleComponent,
    SelectorDatepickerComponent,
    SelectorChipComponent,
    FormsModule,
    ReactiveFormsModule,
    MenuComparacionComponent,
    GpsIndicatorComponent,
    DatePipe,
    TitleCasePipe,
    NgClass,
    LineChartComponent,
    MatRadioGroup,
    MatRadioButton,
    LoadSpinnerComponent,
    BuscadorAutocompleteComponent,
    TooltipDirective,
    MatTooltipModule,
    CollapsiblePopupShellComponent,
  ],
  templateUrl: './teledeteccion.component.html',
  styleUrl: './teledeteccion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TeledeteccionComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @ViewChild('comparacionChip') comparacionChip!: ChipsMapButtonsComponent;
  @ViewChild('indicesChip') indicesChip!: SelectorChipComponent;
  @ViewChild('escalaChip') escalaChip!: SelectorChipComponent;
  @ViewChild('datepickerChip') datepickerChip!: SelectorDatepickerComponent;
  @ViewChild('menuComparacion') menuComparacion!: MenuComparacionComponent;

  @ViewChild('map', { read: ElementRef })
  mapContainer?: ElementRef<HTMLDivElement>;
  myMap = signal<Map | null>(null);

  lyrGoogleSatellite = signal<TileLayer>(null);
  lyrGoogleHybrid = signal<TileLayer>(null);
  lyrGoogleRoads = signal<TileLayer>(null);
  lyrGoogleTraffic = signal<TileLayer>(null);
  lyrOSM = signal<TileLayer>(null);
  lyrPNOA = signal<TileLayer.WMS>(null);
  lyrCatastro = signal<TileLayer.WMS>(null);
  options = signal<MapOptions | null>(null);

  leftLayerGroup = signal<LayerGroup>(new LayerGroup());
  rightLayerGroup = signal<LayerGroup>(new LayerGroup());

  imageBlur = signal<boolean>(true);
  readonly dateInfoTooltipText =
    'Mostramos la fecha anterior más cercana con datos disponibles para el área seleccionada y con un porcentaje de nubes menor al 20%.';

  companyData = signal<any>(null);
  companyId = computed(() => {
    const userData = this.authService.getUserLogin();
    return userData?.company_id ? parseInt(userData.company_id, 10) : null;
  });

  area_geojson = computed(() => {
    return this.companyData()?.geojson || null;
  });

  get indiceTooltipText() {
    return INDICE_TOOLTIP_TEXT;
  }

  get isVisibleIndexSelected(): boolean {
    return this.indicesChip?.getSelectedElement()?.value === 'VISIBLE';
  }

  // Efecto: aplicar o quitar blur dinámicamente cuando cambia imageBlur,
  // únicamente si hay un área seleccionada y se está mostrando un índice (overlay) para esa área.
  private _imageBlurEffect = effect(() => {
    const _shouldBlur = this.imageBlur(); // dependencia principal
    const sel = this.selectedArea?.(); // dependencia secundaria (si es signal)
    const map = this.myMap();
    if (!map || !sel?.id) return;
    const areaId = sel.id;
    const inComparison = this.showMenuComparacion?.() ?? false;

    if (inComparison) {
      const leftActive = this.overlaysBySide.left.has(areaId);
      const rightActive = this.overlaysBySide.right.has(areaId);
      if (!leftActive && !rightActive) return; // no hay índice visible para el área
      const leftPane = map.getPane('split-left');
      const rightPane = map.getPane('split-right');
      if (leftPane) this.processImageBlur(leftPane, 'left');
      if (rightPane) this.processImageBlur(rightPane, 'right');
      return;
    }

    // Modo normal
    const primaryActive = this.overlaysBySide.primary.has(areaId);
    if (!primaryActive) return;
    // El pane 'default-pane' se crea cuando se añade el overlay primario
    const defaultPane = map.getPane('default-pane');
    if (defaultPane) this.processImageBlur(defaultPane, 'primary');
  });

  // Efecto: mostrar/ocultar la máscara inversa del área de trabajo siempre que haya datos de geojson
  private _areaMaskEffect = effect(() => {
    const areaGeojson = this.area_geojson();
    const map = this.myMap();

    if (!map) return;

    // Remover capa existente si existe
    if (this.areaMaskLayer) {
      map.removeLayer(this.areaMaskLayer);
      this.areaMaskLayer = null;
    }

    // Agregar máscara siempre que hay datos de geojson
    if (areaGeojson) {
      setTimeout(() => {
        this.createAreaMask(areaGeojson);
      }, 0);
    }
  });

  // Propiedades para LeafletDraw
  drawOptions: any;
  drawnItems: FeatureGroup = featureGroup();
  drawAreaGeometry: any;
  isDrawing = signal<boolean>(false);
  subscriptions: Subscription[] = [];
  // Cache de peticiones de índices: key = `${date}|${index}|${areaId}`
  // Usamos globalThis.Map para no colisionar con el tipo Map de Leaflet importado arriba
  private indexRequestCache: globalThis.Map<string, Observable<any>> =
    new globalThis.Map<string, Observable<any>>();
  private readonly INDEX_CACHE_MAX = 300;
  private escKeyListener?: (event: KeyboardEvent) => void;
  private leftFormSub?: Subscription;
  private rightFormSub?: Subscription;
  // Overlays (ImageOverlay o GeoRasterLayer) por lado
  private overlaysBySide: {
    primary: globalThis.Map<number, L.Layer>;
    left: globalThis.Map<number, L.Layer>;
    right: globalThis.Map<number, L.Layer>;
  } = {
    primary: new globalThis.Map<number, L.Layer>(),
    left: new globalThis.Map<number, L.Layer>(),
    right: new globalThis.Map<number, L.Layer>(),
  };

  // Capa de máscara inversa para limitar el área de trabajo
  private areaMaskLayer: L.GeoJSON = null;
  // Variables para validar área permitida durante el dibujo
  private allowedAreaGeojson: any = null;
  private drawingHandler: any = null;

  // Últimos parámetros usados por área y lado para evitar repetir solicitudes innecesarias
  private lastParamsBySide: {
    primary: globalThis.Map<number, string>;
    left: globalThis.Map<number, string>;
    right: globalThis.Map<number, string>;
  } = {
    primary: new globalThis.Map<number, string>(),
    left: new globalThis.Map<number, string>(),
    right: new globalThis.Map<number, string>(),
  };

  // Versión para invalidar el computed cuando cambian fechas
  private imageDateVersion = signal<number>(0);

  // Fecha graficada reactiva basada en signals y versión
  plottedImageDate = computed(() => {
    // Dependencias
    this.imageDateVersion();
    const sel = this.selectedArea();
    if (!sel?.id) return '';
    const areaId = sel.id;
    const side: 'primary' | 'left' | 'right' = this.showMenuComparacion()
      ? this.overlaysBySide.left.has(areaId)
        ? 'left'
        : this.overlaysBySide.right.has(areaId)
          ? 'right'
          : 'primary'
      : 'primary';
    return this.lastImageDateBySide[side].get(areaId) ?? '';
  });

  // Fechas graficadas reactivas para cada lado en modo comparación
  plottedImageDateLeft = computed(() => {
    this.imageDateVersion(); // Dependencia del signal
    const sel = this.selectedArea();
    if (!sel?.id) return '';
    return this.lastImageDateBySide.left.get(sel.id) ?? '';
  });

  plottedImageDateRight = computed(() => {
    this.imageDateVersion(); // Dependencia del signal
    const sel = this.selectedArea();
    if (!sel?.id) return '';
    return this.lastImageDateBySide.right.get(sel.id) ?? '';
  });

  // Últimos min/max devueltos por el backend por lado y área (para escala específica)
  private lastMinMaxBySide: {
    primary: globalThis.Map<number, { min: number; max: number }>;
    left: globalThis.Map<number, { min: number; max: number }>;
    right: globalThis.Map<number, { min: number; max: number }>;
  } = {
    primary: new globalThis.Map<number, { min: number; max: number }>(),
    left: new globalThis.Map<number, { min: number; max: number }>(),
    right: new globalThis.Map<number, { min: number; max: number }>(),
  };

  // Última fecha de imagen devuelta por el backend por lado y área
  private lastImageDateBySide: {
    primary: globalThis.Map<number, string>;
    left: globalThis.Map<number, string>;
    right: globalThis.Map<number, string>;
  } = {
    primary: new globalThis.Map<number, string>(),
    left: new globalThis.Map<number, string>(),
    right: new globalThis.Map<number, string>(),
  };

  // Controles del mapa
  ctlZoomSlider: any;
  ctlZoomIn: any;
  ctlZoomOut: any;
  ctlMeasureButton: any;
  ctlCenterButton: any;
  ctlMyLocationButton: any;
  ctlPrintButton: Control.EasyButton | null = null;
  ctlInfoButton: any;
  ctlLayerSwitcher: any;
  splitMapControl: any;
  private splitMapActive = false;
  // Bases por lado cuando el split está activo
  private leftBaseLayer: any = null;
  private rightBaseLayer: any = null;
  // Listeners cleanup for split overlay pane clipping
  private _splitListenersBound = false;
  private _onDividerMove?: () => void;
  private _onMapMove?: () => void;
  private _onMapZoom?: () => void;
  private _onMapResize?: () => void;
  private _clipRedrawRaf?: number | null;
  private _clipWatcherRaf?: number | null;
  private _lastClipX?: number | null;
  private _clipRedrawTimeout?: number | null;
  // Variables para gestión de ubicación del usuario
  userLocationMarker: any = null;
  userLocationCircle: any = null;

  // Variable para gestión de capas
  currentLayerType: string = 'satellite';
  // Capa de borde para el área seleccionada cuando se muestra su índice
  private areaBorderLayer: L.GeoJSON | null = null;
  private readonly AREA_BORDER_PANE = 'area-border-pane';
  private printContainer: HTMLElement | null = null;
  private printMediaQuery: MediaQueryList | null = null;
  private printMediaListener: ((event: MediaQueryListEvent) => void) | null =
    null;
  private afterPrintHandler: (() => void) | null = null;
  private printTimeoutId: number | null = null;

  // --- Histórico índice (popup área) ---
  showHistoricChart = signal<boolean>(false); // controla si se muestra el chart
  loadingHistoric = signal<boolean>(false);
  historicError = signal<string | null>(null);
  historicChartData = signal<ChartData<'line'>>({ labels: [], datasets: [] });
  historicColors = { current: '#00afef', previous: '#DF7B00' };
  historicYMin = signal<number | null>(null);
  historicYMax = signal<number | null>(null);
  selectedHistoricMetric = signal<'median' | 'mean' | 'min' | 'max'>('median');

  get historicLabeledNameForLegend() {
    switch (this.selectedHistoricMetric()) {
      case 'mean':
        return 'promedio';
      case 'min':
        return 'mínimo';
      case 'max':
        return 'máximo';
      default:
        return 'mediana';
    }
  }

  historicYAxisTitle = () => {
    return 'Escala específica';
    /* switch (this.selectedHistoricMetric()) {
      case 'mean':
        return 'Promedio';
      case 'min':
        return 'Mínimo';
      case 'max':
        return 'Máximo';
      default:
        return 'Mediana';
    } */
  };
  // Última clave de request ejecutada para evitar duplicados
  private _lastHistoricRequestKey: string | null = null;
  // Signal para forzar la re-ejecución del effect cuando cambian los filtros
  private _historicTrigger = signal<number>(0);

  // Effect único para cargar/recargar histórico al cambiar área, índice, fecha o métrica seleccionada
  private _historicAutoLoader = effect(() => {
    // Leer el trigger para que el effect se vuelva a ejecutar cuando cambia
    this._historicTrigger();

    if (!this.showAreaInfo() || !this.showHistoricChart()) return; // popup o histórico no visibles
    const area = this.selectedArea();
    const fg = this.primaryFilterFormGroup();
    if (!area || !fg) return;
    const indiceVal = extractIndiceValue(fg.value?.indice);
    const fechaVal = extractDateString(fg.value?.fecha);
    const metric = this.selectedHistoricMetric();
    if (!indiceVal || !fechaVal) return;
    const key = `${area.id}|${indiceVal}|${fechaVal}|${metric}`;
    if (this._lastHistoricRequestKey === key) return; // ya cargado con estos parámetros
    this._lastHistoricRequestKey = key;
    this.historicChartData.set({ labels: [], datasets: [] });
    setTimeout(() => this.loadHistoricData(), 0);
  });

  getSelectedIndiceName = () => {
    const primaryForm = this.primaryFilterFormGroup();
    if (!primaryForm) return '';
    const indice = primaryForm.value?.indice;
    // Puede venir como string ("NDVI") o como objeto { label, value }
    let name = '';
    if (typeof indice === 'string') {
      name = indice;
    } else if (indice && typeof indice === 'object') {
      name = indice.viewValue || indice.value || '';
    }
    if (
      !name &&
      Array.isArray(this.indicesVegetacion) &&
      this.indicesVegetacion.length
    ) {
      const first = this.indicesVegetacion[0];
      if (typeof first === 'string') name = first;
      else if (first && typeof first === 'object') {
        name = first.viewValue || first.value || '';
      }
    }
    return (name || '').toUpperCase();
  };

  onHistoricMetricChange(metric: 'median' | 'mean' | 'min' | 'max') {
    if (this.selectedHistoricMetric() === metric) return;
    this.selectedHistoricMetric.set(metric);
    // Re-generar dataset con la métrica elegida a partir de última respuesta cacheada (no guardamos crudo aún)
    // Para simplicidad volvemos a pedir datos (así aseguramos consistencia). Opcional: cachear última respuesta de cada año.
    this.loadHistoricData();
  }

  /**
   * Construye los datos para el gráfico histórico a partir de dos respuestas (año actual y anterior)
   */
  private buildHistoricChartData(
    currentResponse: any,
    previousResponse: any
  ): ChartData<'line'> {
    const current = this.parseHistoricSeries(currentResponse);
    const previous = this.parseHistoricSeries(previousResponse);
    const pointCount = Math.max(current.length, previous.length);

    // Respetamos el orden del backend porque el rango puede cruzar de un año a otro
    // y el número de semana vuelve a 1 dentro de la misma línea temporal.
    const labels: string[] = [];
    const currentData: (number | null)[] = [];
    const previousData: (number | null)[] = [];

    for (let index = 0; index < pointCount; index++) {
      const currentWeek = current[index];
      const previousWeek = previous[index];
      const label =
        currentWeek?.label || previousWeek?.label || `Semana ${index + 1}`;
      labels.push(label);
      currentData.push(currentWeek?.value ?? null);
      previousData.push(previousWeek?.value ?? null);
    }

    const currentYear = this.getHistoricResponseYear(currentResponse, current);
    const previousYear = this.getHistoricResponseYear(
      previousResponse,
      previous
    );

    return {
      labels,
      datasets: [
        {
          label:
            `Valor ${this.historicLabeledNameForLegend} año ${currentYear ?? ''}`.trim(),
          data: currentData,
          borderColor: this.historicColors.current,
          backgroundColor: 'transparent',
          pointRadius: 3,
          pointHoverRadius: 5,
          spanGaps: true,
        },
        {
          label:
            `Valor ${this.historicLabeledNameForLegend} año ${previousYear ?? ''}`.trim(),
          data: previousData,
          borderColor: this.historicColors.previous,
          backgroundColor: 'transparent',
          pointRadius: 3,
          pointHoverRadius: 5,
          spanGaps: true,
        },
      ],
    };
  }

  private parseHistoricSeries(response: any) {
    const weeklyStats: Array<{ week_start?: string; week_number?: number }> =
      Array.isArray(response?.weekly_stats) ? response.weekly_stats : [];

    return weeklyStats
      .filter((week: { week_start?: string; week_number?: number }) =>
        Boolean(week?.week_start && week?.week_number)
      )
      .map((week: { week_start?: string; week_number?: number }) => ({
        label: this.buildWeekLabel(week),
        value: this.pickMetricValue(week),
        weekStart: week.week_start,
      }));
  }

  private getHistoricResponseYear(
    response: any,
    series: Array<{ weekStart?: string }>
  ): number | null {
    const dateTo =
      typeof response?.date_to === 'string' ? response.date_to.trim() : '';
    const dateToYear = Number.parseInt(dateTo.slice(0, 4), 10);
    if (!Number.isNaN(dateToYear)) return dateToYear;

    for (let index = series.length - 1; index >= 0; index--) {
      const weekStart = series[index]?.weekStart;
      if (!weekStart) continue;
      const rawYear = Number.parseInt(weekStart.slice(0, 4), 10);
      if (!Number.isNaN(rawYear)) return rawYear;
    }

    return null;
  }

  private pickMetricValue(w: any) {
    const metric = this.selectedHistoricMetric();
    switch (metric) {
      case 'mean':
        return w.mean_value ?? null;
      case 'min':
        return w.min_value ?? null;
      case 'max':
        return w.max_value ?? null;
      default:
        return w.median_value ?? null;
    }
  }

  private buildWeekLabel(w: any): string {
    // Formato requerido: "Semana X" (línea 1) y "Mes" completo (línea 2)
    // Usamos salto de línea para que Chart.js pinte dos líneas por etiqueta
    try {
      const d = new Date(w.week_start);
      let monthFull = d.toLocaleString('es-ES', { month: 'long' });
      if (monthFull && monthFull.length) {
        monthFull = monthFull.charAt(0).toUpperCase() + monthFull.slice(1);
      }
      return `Semana ${w.week_number}\n${monthFull}`; // Chart.js interpreta '\n' como salto de línea
    } catch {
      return `Semana ${w.week_number}`;
    }
  }

  onClickShowHistoric() {
    // Si ya cargamos, solo togglear mostrar
    if (this.showHistoricChart() && this.historicChartData().datasets.length) {
      this.showHistoricChart.set(false);
      return;
    }
    // Mostrar contenedor y cargar
    this.showHistoricChart.set(true);
    this.loadHistoricData();
  }

  private loadHistoricData() {
    const area = this.selectedArea();
    const primaryForm = this.primaryFilterFormGroup();
    if (!area || !primaryForm) return;
    const indice = extractIndiceValue(primaryForm.value?.indice);
    const fecha = extractDateString(primaryForm.value?.fecha);
    if (!indice || !fecha) return;
    const metric = this.selectedHistoricMetric();
    const key = `${area.id}|${indice}|${fecha}|${metric}`;
    if (this._lastHistoricRequestKey === key && this.loadingHistoric()) {
      // Ya hay una petición en curso con los mismos parámetros
      return;
    }
    this._lastHistoricRequestKey = key;
    this.loadingHistoric.set(true);
    this.historicError.set(null);

    // Petición año actual (fecha seleccionada) y año anterior (fecha - 1 año)
    const dateObj = new Date(fecha);
    const prevYearDate = new Date(dateObj);
    prevYearDate.setFullYear(dateObj.getFullYear() - 1);
    const prevDateStr = prevYearDate.toISOString().slice(0, 10);

    const obsCurrent = this.teleService.getWeeklyIndexStats({
      date: fecha,
      area_id: area.id!,
      index_name: indice,
    });
    const obsPrevious = this.teleService.getWeeklyIndexStats({
      date: prevDateStr,
      area_id: area.id!,
      index_name: indice,
    });

    forkJoin([obsCurrent, obsPrevious])
      .pipe(
        finalize(() => this.loadingHistoric.set(false)),
        catchError(err => {
          this.historicError.set('No se pudo cargar el histórico');
          throw err;
        })
      )
      .subscribe(([curr, prev]) => {
        const chartData = this.buildHistoricChartData(curr, prev);
        this.historicChartData.set(chartData);
        this.computeHistoricYRange();
      });
  }

  private computeHistoricYRange() {
    const ds = this.historicChartData().datasets || [];
    const allValues: number[] = [];
    ds.forEach(d => {
      (d.data as any[]).forEach(v => {
        if (v === 0 || (v && !isNaN(v))) {
          const num = Number(v);
          if (!isNaN(num)) allValues.push(num);
        }
      });
    });
    if (!allValues.length) {
      this.historicYMin.set(null);
      this.historicYMax.set(null);
      return;
    }
    const min = Math.min(...allValues);
    const max = Math.max(...allValues);
    if (min === max) {
      // Caso línea plana: dar un padding para verla
      const pad = min === 0 ? 1 : Math.abs(min) * 0.1;
      this.historicYMin.set(min - pad);
      this.historicYMax.set(max + pad);
    } else {
      const span = max - min;
      const pad = span * 0.1; // 10% padding
      this.historicYMin.set(min - pad);
      this.historicYMax.set(max + pad);
    }
  }

  showScale = signal<boolean>(true);
  showSecondScale = signal<boolean>(false);
  showMenuComparacion = signal<boolean>(false);
  // Debounce simple para el toggle de comparación
  private comparationToggleLock = false;
  private readonly COMPARISON_TOGGLE_DEBOUNCE_MS = 150;

  fb: FormBuilder = new FormBuilder();

  primaryLayerGroup = signal<LayerGroup>(new LayerGroup());

  primaryFilterFormGroup = signal<FormGroup>(null);
  rightFilterFormGroup = signal<FormGroup>(null);
  leftFilterFormGroup = signal<FormGroup>(null);

  selectedArea = signal<TeledeteccionArea | null>(null);

  // Variable para guardar el estado original del primaryFilterFormGroup
  private originalPrimaryFormState = signal<any>(null);

  get indicesVegetacion() {
    return SELECT_INDICE_VEGETACION;
  }

  timeout = signal<any>(null);
  lat = signal<string>('0.00000');
  long = signal<string>('0.00000');

  // Throttle para mousemove (reduce CPU)
  private mouseMoveThrottleId: any = null;
  private mouseMoveLast: { lat: number; lng: number } | null = null;
  private readonly MOUSEMOVE_THROTTLE_MS = 100; // ajustar si se desea más/menos fluidez

  showAreaInfo = signal<boolean>(true);
  areaInfoExpanded = signal<boolean>(true);
  isLoadingAreaData = signal<boolean>(false);
  // Mensaje inferior (estilo Visorgis) para casos sin datos
  showBottomMessage = signal<boolean>(false);
  showBottomMessageIcon = signal<boolean>(true);
  bottomMessage = signal<string>(
    'No se encuentran datos para los filtros seleccionados'
  );
  // Mostrar/ocultar el indicador GPS cuando se despliega el modal de creación de área
  showGpsIndicator = signal<boolean>(true);
  // Overlay global para bloquear y aplicar blur a toda la página
  private globalLoaderEl: HTMLDivElement | null = null;
  private globalLoaderTimer: any = null;
  private readonly GLOBAL_LOADER_DELAY_MS = 500; // mismo delay que el loader local eliminado

  // Propiedades para gestión de áreas de teledetección
  private areaLayers: Array<{
    id: number;
    layer: L.GeoJSON;
    area: TeledeteccionArea;
  }> = [];

  // Buscador de áreas
  searchTerm: FormControl = new FormControl();
  searchAreas = signal<SearchItem[]>([]);

  escalas = [
    { value: 'general', viewValue: 'Escala general' },
    { value: 'especifica', viewValue: 'Escala específica' },
  ];

  /**
   * Devuelve las opciones de escala disponibles para un lado concreto.
   * Por defecto solo se muestra 'general'. 'específica' solo aparece cuando
   * hay un área seleccionada y existe un overlay (índice mostrado) para ese lado.
   */
  getScaleOptionsForSide(
    side: 'primary' | 'left' | 'right'
  ): SelectorElement[] {
    try {
      const hasOverlay = this.hasActiveOverlayForSide(side);
      if (hasOverlay) return this.escalas;
      return [this.escalas[0]]; // solo 'general'
    } catch {
      return [this.escalas[0]];
    }
  }

  /**
   * Indica si existe overlay para el área seleccionada en el lado indicado
   * (esto implica que el índice está siendo mostrado).
   */
  private hasActiveOverlayForSide(side: 'primary' | 'left' | 'right'): boolean {
    const sel = this.selectedArea();
    if (!sel?.id) return false;
    const areaId = sel.id;
    const map = this.overlaysBySide?.[side];
    return !!map?.has(areaId);
  }

  /**
   * Cierra el popup de información del área y restablece el estado inicial:
   * - Oculta la info del área
   * - Quita cualquier overlay activo del área seleccionada
   * - Devuelve el estilo de las áreas a gris
   * - Des-selecciona el área
   */
  onCloseAreaInfo(): void {
    try {
      this.showAreaInfo.set(false);
      this.areaInfoExpanded.set(true);
      this.showBottomMessage.set(false);
      this.showHistoricChart.set(false); // Resetear el histórico al cerrar el popup
      const selId = this.selectedArea()?.id;
      if (selId != null) {
        // Eliminar overlays del área seleccionada en todos los lados
        this.clearOverlaysForArea(selId);
      }
      // Des-seleccionar el área
      this.selectedArea.set(null);
      // Recalcular estilos (volver a gris)
      this.recomputeAreaStyles();
      // Limpiar el borde negro del área seleccionada
      this.updateSelectedAreaBorder();
    } catch (e) {
      console.warn('No se pudo cerrar el popup/restablecer estado', e);
    }
  }

  /**
   * Manejar la selección de un área desde el buscador
   */
  onAreaSelected(searchItem: SearchItem): void {
    console.log('🔍 Área seleccionada desde buscador:', searchItem);

    // Buscar el área en areaLayers por ID
    const areaLayer = this.areaLayers.find(al => al.id === searchItem.id);

    if (areaLayer) {
      const { layer, area } = areaLayer;

      // Centrar el mapa en el área
      if (layer.getBounds) {
        this.myMap()?.setView(layer.getBounds().getCenter(), 17);
      }

      // Seleccionar el área
      this.selectedArea.set(area);
      this.areaInfoExpanded.set(true);
      if (!this.showAreaInfo()) {
        this.showAreaInfo.set(true);
      }
      this.showHistoricChart.set(false); // Resetear el histórico al cambiar de área

      // Obtener la imagen del índice para el área seleccionada
      this.getIndexImageForSelectedArea(layer);
    } else {
      console.warn('⚠️ No se encontró la capa del área con ID:', searchItem.id);
    }
  }

  constructor(
    private readonly visorgisService: VisorgisService,
    private mapaService: MapaService,
    private teleService: TeledeteccionService,
    private modalFormService: ModalFormService,
    private configuracionService: ConfiguracionService,
    private authService: AuthService
  ) {
    // Efecto para mostrar/ocultar overlay global según estado de carga, con delay
    effect(() => {
      const active = this.isLoadingAreaData();
      if (active) {
        // Si se activa la carga, esperar el delay antes de mostrar
        if (this.globalLoaderEl) return; // ya visible
        if (this.globalLoaderTimer) return; // ya hay un timer en curso
        this.globalLoaderTimer = setTimeout(() => {
          this.globalLoaderTimer = null;
          if (this.isLoadingAreaData()) this.showGlobalLoader();
        }, this.GLOBAL_LOADER_DELAY_MS);
      } else {
        // Si deja de cargar, cancelar cualquier timer y ocultar
        if (this.globalLoaderTimer) {
          clearTimeout(this.globalLoaderTimer);
          this.globalLoaderTimer = null;
        }
        this.hideGlobalLoader();
      }
    });
    effect(() => {
      if (
        isLeafletMapReady(this.myMap()) &&
        this.leftLayerGroup() &&
        this.rightLayerGroup()
      ) {
        if (this.showMenuComparacion() && !this.splitMapActive) {
          // Asegurar que los LayerGroups tienen capas antes de crear el control
          /* this.ensureLayerGroupsHaveLayers(); */

          // Solo crear el control si no existe
          if (!this.splitMapControl) {
            console.log('🔧 Creando control splitmap...');
            // Esperar a que el mapa esté completamente listo antes de crear el control
            waitForLeafletMapReady(() => isLeafletMapReady(this.myMap())).then(
              () => {
                try {
                  // Preparar bases por lado y añadirlas al mapa ANTES de instanciar el control
                  prepareSplitGroups(
                    this.leftLayerGroup(),
                    this.rightLayerGroup(),
                    () => this.mapaService.getLyrGoogleSattellite()
                  );
                  const leftLayers = this.leftLayerGroup().getLayers?.() || [];
                  const rightLayers =
                    this.rightLayerGroup().getLayers?.() || [];
                  this.leftBaseLayer =
                    leftLayers[0] ?? this.mapaService.getLyrGoogleSattellite();
                  this.rightBaseLayer =
                    rightLayers[0] ?? this.mapaService.getLyrGoogleSattellite();

                  // Asegurar que las bases están en el mapa antes de crear el control
                  const map = this.myMap();
                  if (map) {
                    if (!map.hasLayer(this.leftBaseLayer)) {
                      map.addLayer(this.leftBaseLayer);
                    }
                    if (!map.hasLayer(this.rightBaseLayer)) {
                      map.addLayer(this.rightBaseLayer);
                    }
                  }

                  // Instanciar el control con arrays de capas reales (no LayerGroup)
                  this.splitMapControl = L.control.splitMap(
                    [this.leftBaseLayer],
                    [this.rightBaseLayer]
                  );
                  // Agregar al mapa inmediatamente después de crear
                  if (this.splitMapControl && map) {
                    map.addControl(this.splitMapControl);
                    this.splitMapActive = true;
                    this.installSplitUpdateLayersOverride();
                    // Si ya existen overlays por lado, añadirlos al mapa y actualizar control
                    this.ensureSideLayersOnMap('left');
                    this.ensureSideLayersOnMap('right');
                    this.updateSplitMapLayers();
                    // Mantener clip correcto para panes de overlays
                    this.bindSplitOverlayPaneClipping();
                    // El plugin maneja el clipping internamente
                  }
                } catch (error) {
                  console.error('❌ Error al crear control splitmap:', error);
                  this.splitMapControl = null;
                  this.splitMapActive = false;
                }
              }
            );
            return; // Salir aquí para evitar la lógica de agregar al mapa
          }
        } else if (!this.showMenuComparacion() && this.splitMapActive) {
          // Remover del mapa si existe y está activo
          if (this.splitMapControl) {
            console.log('🔧 Removiendo control splitmap...');
            try {
              this.myMap().removeControl(this.splitMapControl);
              this.splitMapControl = null; // Resetear la variable para permitir recreación
              this.splitMapActive = false;
              this.unbindSplitOverlayPaneClipping();
              // Remover capas de comparación del mapa
              this.removeSideLayersFromMap('left');
              this.removeSideLayersFromMap('right');
              try {
                if (
                  this.leftBaseLayer &&
                  this.myMap()?.hasLayer(this.leftBaseLayer)
                ) {
                  this.myMap().removeLayer(this.leftBaseLayer);
                }
                if (
                  this.rightBaseLayer &&
                  this.myMap()?.hasLayer(this.rightBaseLayer)
                ) {
                  this.myMap().removeLayer(this.rightBaseLayer);
                }
              } catch {}
              this.leftBaseLayer = null;
              this.rightBaseLayer = null;
              // Forzar invalidación del tamaño del mapa para asegurar que se renderice bien después
              this.myMap()?.invalidateSize();
              console.log(
                '✅ Control splitMap removido y reseteado correctamente'
              );
            } catch (error) {
              console.error('❌ Error al remover control splitmap:', error);
              this.splitMapControl = null; // Resetear incluso si hay error
              this.splitMapActive = false;
            }
          }
        }
        // No need for manual change detection; signals drive UI updates
      }
    });
  }

  /**
   * Inicializar valores por defecto de los selectores y configurar observadores
   */
  private initializeSelectors(): void {
    // Los valores por defecto ahora se establecen en el FormGroup en ngOnInit
    console.log('🔧 Inicializando observadores de selectores...');
  }

  /**
   * Obtener el índice seleccionado actualmente
   */
  getSelectedIndice(): SelectorElement | null {
    const selected = this.primaryFilterFormGroup()?.controls['indice']?.value;
    return selected;
  }

  /**
   * Obtener la escala seleccionada actualmente
   */
  getSelectedEscala(): SelectorElement | null {
    const selected = this.primaryFilterFormGroup()?.controls['escala']?.value;
    return selected;
  }

  ngOnInit(): void {
    this.setDrawLocal();
    this.initDrawOptions();
    this.initializeSelectors();
    this.initUserSettings();
    this.primaryFilterFormGroup.set(
      this.fb.group({
        indice: [this.indicesVegetacion[0]], // NDVI como valor por defecto
        escala: [this.escalas[0]], // Primera escala como valor por defecto
        escala_min: [-1],
        escala_max: [1],
        fecha: [new Date()],
      })
    );

    // Suscribirse a cambios en el primaryFilterFormGroup para recalcular SOLO el área seleccionada
    const primary = this.primaryFilterFormGroup();
    if (primary) {
      const sub = primary.valueChanges
        .pipe(
          // Reaccionar ante cambios de fecha, índice o escala
          map((v: any) => ({
            fecha: v?.fecha,
            indice: v?.indice,
            escala: v?.escala,
          })),
          debounceTime(300),
          distinctUntilChanged(
            (a: any, b: any) =>
              (extractDateString(a.fecha) || null) ===
                (extractDateString(b.fecha) || null) &&
              (extractIndiceValue(a.indice) || null) ===
                (extractIndiceValue(b.indice) || null) &&
              (a?.escala?.value ?? null) === (b?.escala?.value ?? null)
          ),
          filter(
            (v: any) =>
              !!extractDateString(v.fecha) && !!extractIndiceValue(v.indice)
          )
        )
        .subscribe(() => {
          if (this.showMenuComparacion()) return; // en comparación no disparamos primario
          const sel = this.selectedArea();
          const areaId = sel?.id;
          if (!areaId) return; // no hay área seleccionada
          this.requestAndRenderIndexForArea(areaId, 'primary');

          // Trigger para recargar el histórico si está visible
          if (this.showAreaInfo() && this.showHistoricChart()) {
            this._historicTrigger.update(v => v + 1);
          }
        });
      this.subscriptions.push(sub);
    }

    // Agregar listener para la tecla ESC para cancelar el dibujo
    this.escKeyListener = event => {
      if (event.key === 'Escape' && this.isDrawing()) {
        console.log('ESC presionado - Cancelando dibujo');
        this.cancelDraw();
      }
    };
    document.addEventListener('keydown', this.escKeyListener);

    // Inicializar las capas del mapa
    this.lyrGoogleSatellite.set(this.mapaService.getLyrGoogleSattellite());
    this.lyrGoogleHybrid.set(this.mapaService.getLyrGoogleHybrid());
    this.lyrGoogleRoads.set(this.mapaService.getLyrGoogleRoads());
    this.lyrGoogleTraffic.set(this.mapaService.getLyrGoogleTraffic());
    this.lyrOSM.set(this.mapaService.getLyrOSM());
    this.lyrPNOA.set(this.mapaService.getLyrPNOA());
    this.lyrCatastro.set(this.mapaService.getLyrCatastro());

    // Configurar opciones del mapa
    this.options.set({
      layers: [this.lyrGoogleSatellite()],
      zoom: 6,
      center: latLng(environment.gis_posicion as LatLngExpression),
      minZoom: 6,
      zoomControl: false,
      attributionControl: false,
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.myMap()?.invalidateSize();
    }, 100);

    // Suscribirse para cancelar el dibujo cuando se cierre el modal sin crear
    this.cancelDrawSubscription();
  }
  onMapReady(map) {
    this.myMap.set(map);

    this.primaryLayerGroup()
      .addLayer(this.lyrGoogleSatellite())
      .addTo(this.myMap());
    // Agregar la capa de elementos dibujados al mapa
    this.drawnItems.addTo(this.myMap());
    // Crear panes personalizados SOLO para overlays de teledetección en modo comparación
    try {
      const mp = this.myMap();
      if (mp && !mp.getPane('split-left')) {
        mp.createPane('split-left');
        mp.getPane('split-left').style.zIndex = '450';
      }
      if (mp && !mp.getPane('split-right')) {
        mp.createPane('split-right');
        mp.getPane('split-right').style.zIndex = '450';
      }
    } catch {}

    // Nota: no creamos panes personalizados para bases; el plugin gestiona el clipping
    // Preparar LayerGroups (no se añaden todavía para evitar solape fuera de comparación)
    ensureLayerGroupHasBase(
      this.leftLayerGroup(),
      this.mapaService.getLyrGoogleSattellite()
    );
    ensureLayerGroupHasBase(
      this.rightLayerGroup(),
      this.mapaService.getLyrGoogleSattellite()
    );
    // Pane superior para dibujar el borde negro del área seleccionada sobre los overlays
    try {
      const mp = this.myMap();
      if (mp && !mp.getPane(this.AREA_BORDER_PANE)) {
        const p = mp.createPane(this.AREA_BORDER_PANE);
        p.style.zIndex = '460'; // por encima de los overlays (450)
        p.style.pointerEvents = 'none'; // no bloquear interacciones
      }
    } catch {}

    // Invalidar el tamaño del mapa para asegurar que esté completamente renderizado
    setTimeout(() => {
      this.myMap().invalidateSize();
    }, 100);

    // Control de zoom slider (mantener el existente)
    this.ctlZoomSlider = this.mapaService
      .getZoomSliderBar('topleft')
      .addTo(this.myMap());

    this.ctlLayerSwitcher = this.mapaService
      .getLayerSwitcherButton(this)
      .addTo(this.myMap());

    // Botón de centrado manual
    this.ctlCenterButton = this.mapaService
      .getInitialPosition(this)
      .addTo(this.myMap());

    // Botón "Estoy aquí"
    this.ctlMyLocationButton = this.mapaService
      .getMyLocationButton(this)
      .addTo(this.myMap());

    // CORREGIR UN ERROR CON LA VERSION 1.8.0 de LEAFLET PARA ANGULAR
    L.Control.Measure.include({
      _setCaptureMarkerIcon() {
        this._captureMarker.options.autoPanOnFocus = false;
        this._captureMarker.setIcon(
          L.divIcon({
            iconSize: this._map.getSize().multiplyBy(2),
          })
        );
      },
    });
    // Herramienta de medición
    this.ctlMeasureButton = this.mapaService
      .getMeasureButton(this)
      .addTo(this.myMap());

    // Botón de impresión
    this.setupPrintButton();

    // Botón de información
    this.ctlInfoButton = this.mapaService
      .getInfoButton(this, {
        url: 'https://cuatroplus.atlassian.net/wiki/x/G4DWFQ',
      })
      .addTo(this.myMap());

    // Cargar todas las áreas existentes al inicializar
    this.loadAllAreas();
    console.log('PASE EL METODO');
  }

  private setupPrintButton(): void {
    const map = this.myMap();
    if (!map) return;

    if (this.ctlPrintButton) {
      map.removeControl(this.ctlPrintButton);
      this.ctlPrintButton = null;
    }

    this.ctlPrintButton = L.easyButton({
      id: 'tele-print-button',
      position: 'topleft',
      states: [
        {
          stateName: 'default',
          icon: `<i class='material-symbols-rounded map-button' translate='no'>print</i>`,
          title: 'Imprimir mapa e información',
          onClick: () => this.handlePrintClick(),
        },
      ],
    });

    this.ctlPrintButton.addTo(map);
  }

  private handlePrintClick(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const mapElement = this.mapContainer?.nativeElement;
    if (!mapElement) {
      console.warn('No se encontró el contenedor del mapa para imprimir.');
      return;
    }

    this.teardownPrintLayout();

    const printContainer = this.buildPrintContainer(mapElement);
    this.printContainer = printContainer;

    document.body.appendChild(printContainer);
    document.body.classList.add('tele-print-mode');

    this.afterPrintHandler = () => {
      this.clearPrintState();
    };
    window.addEventListener('afterprint', this.afterPrintHandler);

    if (typeof window.matchMedia === 'function') {
      this.printMediaQuery = window.matchMedia('print');
      if (this.printMediaQuery) {
        this.printMediaListener = event => {
          if (!event.matches) {
            this.clearPrintState();
          }
        };

        if (typeof this.printMediaQuery.addEventListener === 'function') {
          this.printMediaQuery.addEventListener(
            'change',
            this.printMediaListener
          );
        } else if (
          typeof (this.printMediaQuery as any).addListener === 'function'
        ) {
          (this.printMediaQuery as any).addListener(this.printMediaListener);
        }
      }
    }

    setTimeout(() => this.myMap()?.invalidateSize(), 30);

    this.printTimeoutId = window.setTimeout(() => {
      window.print();
      this.printTimeoutId = null;
    }, 60);
  }

  private clearPrintState(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    if (this.afterPrintHandler) {
      window.removeEventListener('afterprint', this.afterPrintHandler);
      this.afterPrintHandler = null;
    }

    if (this.printTimeoutId !== null) {
      window.clearTimeout(this.printTimeoutId);
      this.printTimeoutId = null;
    }

    if (this.printMediaQuery && this.printMediaListener) {
      if (typeof this.printMediaQuery.removeEventListener === 'function') {
        this.printMediaQuery.removeEventListener(
          'change',
          this.printMediaListener
        );
      } else if (
        typeof (this.printMediaQuery as any).removeListener === 'function'
      ) {
        (this.printMediaQuery as any).removeListener(this.printMediaListener);
      }
    }

    this.printMediaQuery = null;
    this.printMediaListener = null;

    this.teardownPrintLayout();

    setTimeout(() => {
      this.myMap()?.invalidateSize();
    }, 150);
  }

  private teardownPrintLayout(): void {
    if (typeof document === 'undefined') {
      return;
    }

    if (this.printContainer?.parentElement) {
      this.printContainer.parentElement.removeChild(this.printContainer);
    }
    this.printContainer = null;

    document.body.classList.remove('tele-print-mode');
  }

  private buildPrintContainer(mapElement: HTMLElement): HTMLElement {
    const container = document.createElement('section');
    container.classList.add('tele-print-container');

    // Agregar encabezado con filtros
    const header = this.buildPrintHeader();
    container.appendChild(header);

    const sourceRoot = mapElement.parentElement as HTMLElement | null;
    const teleRoot = sourceRoot
      ? (sourceRoot.cloneNode(true) as HTMLElement)
      : null;

    if (!teleRoot || !sourceRoot) {
      container.appendChild(this.buildFallbackMap(mapElement));
      return container;
    }

    teleRoot.classList.add('tele-print-root');

    this.stripElementsForPrint(teleRoot);
    this.copyCanvasContents(sourceRoot, teleRoot);
    this.copyColorBarBackgrounds(sourceRoot, teleRoot);

    const mapClone = teleRoot.querySelector('#map') as HTMLElement | null;
    if (mapClone) {
      const rect = mapElement.getBoundingClientRect();
      const targetHeight =
        rect.height > 0 ? rect.height : window.innerHeight || 600;
      mapClone.style.height = `${Math.round(targetHeight)}px`;
      mapClone.style.width = '100%';
      mapClone.setAttribute('id', 'map-print');
    }

    this.cloneScaleOverlays().forEach(clone => teleRoot.appendChild(clone));

    container.appendChild(teleRoot);
    return container;
  }

  private buildPrintHeader(): HTMLElement {
    const header = document.createElement('div');
    header.classList.add('tele-print-header');

    // Obtener los valores actuales de los filtros
    const primaryForm = this.primaryFilterFormGroup();
    const indice = primaryForm?.get('indice')?.value?.viewValue || 'N/A';
    const fecha = primaryForm?.get('fecha')?.value;
    const escala = primaryForm?.get('escala')?.value?.viewValue || 'N/A';

    // Formatear la fecha
    let fechaFormateada = 'N/A';
    if (fecha instanceof Date) {
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const anio = fecha.getFullYear();
      fechaFormateada = `${dia}/${mes}/${anio}`;
    }

    // Crear el contenido del encabezado
    header.innerHTML = `
      <div class="tele-print-header-content">
        <div class="tele-print-filter">
          <span class="tele-print-filter-label">Índice:</span>
          <span class="tele-print-filter-value">${indice}</span>
        </div>
        <div class="tele-print-filter">
          <span class="tele-print-filter-label">Fecha:</span>
          <span class="tele-print-filter-value">${fechaFormateada}</span>
        </div>
        <div class="tele-print-filter">
          <span class="tele-print-filter-label">Escala:</span>
          <span class="tele-print-filter-value">${escala}</span>
        </div>
      </div>
    `;

    return header;
  }

  private stripElementsForPrint(root: HTMLElement): void {
    const selectorsToRemove = [
      '.tele-panel-actions',
      '.tele-indices-definition-container',
      '.tele-selected-area-delete-container',
      '.tele-gps-chip-container',
      '.gis-bottom-message',
      '.leaflet-draw-tooltip',
    ];

    selectorsToRemove.forEach(selector => {
      root.querySelectorAll(selector).forEach(el => el.remove());
    });

    root.querySelectorAll('.leaflet-control-container').forEach(el => {
      el.remove();
    });

    root
      .querySelectorAll('[data-leaflet-control], .leaflet-top, .leaflet-bottom')
      .forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.display = 'none';
        }
      });
  }

  private cloneScaleOverlays(): HTMLElement[] {
    const scales = Array.from(
      document.querySelectorAll('.scale-bottom')
    ) as HTMLElement[];

    return scales.map(scale => {
      const clone = scale.cloneNode(true) as HTMLElement;
      clone.classList.add('tele-print-scale-overlay');
      this.copyColorBarBackgrounds(scale, clone);
      return clone;
    });
  }

  private copyCanvasContents(
    sourceRoot: HTMLElement,
    targetRoot: HTMLElement
  ): void {
    if (typeof window === 'undefined') {
      return;
    }

    const sourceCanvases = Array.from(
      sourceRoot.querySelectorAll('canvas')
    ) as HTMLCanvasElement[];
    const targetCanvases = Array.from(
      targetRoot.querySelectorAll('canvas')
    ) as HTMLCanvasElement[];

    targetCanvases.forEach((targetCanvas, index) => {
      const sourceCanvas = sourceCanvases[index];
      if (!sourceCanvas) return;

      try {
        targetCanvas.width = sourceCanvas.width;
        targetCanvas.height = sourceCanvas.height;
        const targetContext = targetCanvas.getContext('2d');
        if (!targetContext) return;
        targetContext.drawImage(sourceCanvas, 0, 0);
      } catch (err) {
        console.warn(
          'No se pudo copiar el contenido del canvas al imprimir',
          err
        );
      }
    });
  }

  private copyColorBarBackgrounds(
    sourceRoot: HTMLElement,
    targetRoot: HTMLElement
  ): void {
    if (typeof window === 'undefined') {
      return;
    }

    const sourceBars = Array.from(
      sourceRoot.querySelectorAll('.color-bar')
    ) as HTMLElement[];
    const targetBars = Array.from(
      targetRoot.querySelectorAll('.color-bar')
    ) as HTMLElement[];

    targetBars.forEach((targetBar, index) => {
      const sourceBar = sourceBars[index];
      if (!sourceBar) return;
      const styles = window.getComputedStyle(sourceBar);
      const background = styles.background;
      const backgroundImage = styles.backgroundImage;
      if (background) {
        targetBar.style.background = background;
      }
      if (backgroundImage && backgroundImage !== 'none') {
        targetBar.style.backgroundImage = backgroundImage;
      }
    });
  }

  private buildFallbackMap(mapElement: HTMLElement): HTMLElement {
    const fallback = document.createElement('section');
    fallback.classList.add('tele-print-fallback');
    const message = document.createElement('p');
    message.textContent =
      'No se pudo preparar el contenido para imprimir. Vuelve a intentarlo.';
    fallback.appendChild(message);

    const mapClone = mapElement.cloneNode(true) as HTMLElement;
    mapClone.style.width = '100%';
    mapClone.style.height = '600px';
    fallback.appendChild(mapClone);
    return fallback;
  }

  onCreateAreaClick(event: any): void {
    console.log('Create area clicked:', event);

    // Funcionalidad toggle: si ya está dibujando, cancelar; si no, activar
    if (this.isDrawing()) {
      console.log('Cancelando modo de dibujo...');
      this.cancelDraw();
    } else {
      console.log('Activando modo de dibujo...');
      this.enableDrawMode();
    }
  }

  // ------------------------------------------
  // #region METODOS DEL DRAW
  setDrawLocal() {
    Object.assign(L.drawLocal, drawLocalConfig);

    // Patch simple para evitar el error "type is not defined"
    if (typeof (window as any).type === 'undefined') {
      (window as any).type = function () {
        return 'm²'; // Siempre retornar metros cuadrados
      };
    }
  }

  initDrawOptions() {
    this.drawOptions = {
      position: 'topleft',
      draw: false, // Desactivar todos los botones de draw por defecto
      edit: false, // Desactivar botones de edición también
    };
  }

  enableDrawMode() {
    this.isDrawing.set(true);
    // Activar el modo de dibujo de polígono programáticamente
    this.startPolygonDraw();
  }

  startPolygonDraw() {
    // Inicializar el handler de dibujo de polígono programáticamente
    if (this.myMap()) {
      // Guardar referencia al geojson del área permitida
      this.allowedAreaGeojson = this.area_geojson();

      // Configurar opciones específicas para evitar el problema de 3 puntos
      const polygonOptions = {
        allowIntersection: false,
        showArea: false, // Deshabilitar el cálculo de área para evitar el error
        drawError: {
          color: '#e1e100',
          message:
            '<strong>Error:</strong> El polígono no puede intersectarse!',
        },
        shapeOptions: {
          color: '#00AEFF',
          weight: 4,
          opacity: 0.8,
          fillOpacity: 0.3,
        },
        // Configuración simple sin medidas
        repeatMode: false,
        // Deshabilitar todas las métricas para evitar errores
        metric: false,
        feet: false,
        nautic: false,
      };

      const polygonDrawer = new L.Draw.Polygon(this.myMap(), polygonOptions);
      this.drawingHandler = polygonDrawer;

      // Limpiar eventos anteriores para evitar conflictos
      this.myMap().off('draw:created');
      this.myMap().off('draw:drawstart');
      this.myMap().off('draw:drawstop');
      this.myMap().off('draw:drawvertex');

      // Configurar eventos de dibujo
      this.myMap().on('draw:created', (e: any) => {
        this.onDrawCreated(e);
      });

      this.myMap().on('draw:drawstart', (e: any) => {
        console.log('Iniciando dibujo de polígono');
      });

      this.myMap().on('draw:drawstop', (e: any) => {
        console.log('Deteniendo dibujo de polígono');
      });

      this.myMap().on('draw:drawvertex', (e: any) => {
        console.log(
          'Vértice añadido, total de vértices:',
          e.layers.getLayers().length
        );
      });

      // Deshabilitar temporalmente el doble clic del mapa para evitar zoom
      this.myMap().doubleClickZoom.disable();

      // Iniciar el modo de dibujo
      polygonDrawer.enable();
    }
  }
  async onDrawCreated(e: any) {
    this.drawnItems.addLayer((e as DrawEvents.Created).layer);
    this.drawAreaGeometry = (
      e as DrawEvents.Created
    ).layer.toGeoJSON().geometry;

    const fixGeometry = {
      type: 'MultiPolygon',
      coordinates: [this.drawAreaGeometry.coordinates],
    };

    console.log('Área creada:', fixGeometry);

    // Establecer el área en creación usando el objeto GeoJSON puro (no el objeto Leaflet)
    this.setCreatingArea(fixGeometry);

    // Reactivar el doble clic del mapa
    this.myMap().doubleClickZoom.enable();

    // Desactivar el modo de dibujo
    this.isDrawing.set(false);

    // Abrir el drawer/modal
    this.modalFormService.openDrawer.next(true);
    this.modalFormService.showingModal.next(true);
  }

  onDrawReady(e: any) {
    console.log('onDrawReady', e);
  }
  cancelDraw() {
    // Deshabilitar el handler de dibujo activo si existe
    if (this.drawingHandler) {
      this.drawingHandler.disable();
    }

    // Limpiar los eventos de dibujo de Leaflet
    if (this.myMap()) {
      this.myMap().off('draw:created');
      this.myMap().off('draw:drawstart');
      this.myMap().off('draw:drawstop');
      this.myMap().off('draw:drawvertex');
    }

    // Limpiar los elementos dibujados
    this.drawnItems.clearLayers();
    this.isDrawing.set(false);

    // Limpiar referencias del área permitida y handler de dibujo
    this.allowedAreaGeojson = null;
    this.drawingHandler = null;

    // Reactivar el doble clic del mapa si estaba deshabilitado
    if (this.myMap()) {
      this.myMap().doubleClickZoom.enable();
    }
  }
  cancelDrawSubscription() {
    const subscription = this.modalFormService.showingModal.subscribe(value => {
      this.showScale.set(!value);
      // Ocultar el indicador GPS cuando el modal está visible; mostrarlo al cerrar
      this.showGpsIndicator.set(!value);
      if (!value) {
        this.drawnItems.clearLayers();
        this.isDrawing.set(false);

        // Limpiar referencias del área permitida y handler de dibujo
        this.allowedAreaGeojson = null;
        this.drawingHandler = null;

        // Reactivar el doble clic del mapa si estaba deshabilitado
        if (this.myMap()) {
          this.myMap().doubleClickZoom.enable();
        }
      }
    });
    this.subscriptions.push(subscription);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());

    // Remover el event listener para evitar memory leaks
    if (this.escKeyListener) {
      document.removeEventListener('keydown', this.escKeyListener);
    }

    // Limpiar el control de splitmap si existe
    if (this.splitMapControl && this.splitMapActive) {
      this.splitMapControl.removeFrom(this.myMap());
      this.splitMapActive = false;
    }

    // Limpiar throttle pendiente
    if (this.mouseMoveThrottleId) {
      clearTimeout(this.mouseMoveThrottleId);
      this.mouseMoveThrottleId = null;
    }

    // Cancelar timer pendiente del loader global
    if (this.globalLoaderTimer) {
      clearTimeout(this.globalLoaderTimer);
      this.globalLoaderTimer = null;
    }

    this.clearPrintState();

    // Asegurar desmontaje del overlay global
    this.hideGlobalLoader();
  }

  /**
   * @description Cambia la capa base del mapa.
   * @param layerKey Clave de la capa a mostrar
   */
  /**
   * @description Cambia la capa base del mapa.
   * @param layerKey Clave de la capa a mostrar
   */
  changeMapLayer(layerKey: string) {
    const newLayer = this.mapaService.getLyrByKey(layerKey);

    // Limpiar capas actuales
    this.primaryLayerGroup().clearLayers();

    // Agregar la nueva capa base y los elementos geojson
    this.primaryLayerGroup().addLayer(newLayer);

    // Actualizar el tipo de capa actual
    this.currentLayerType = layerKey;
  }
  /**
   * Cargar todas las áreas desde el servicio y mostrarlas en el mapa
   */
  private loadAllAreas(showLoader: boolean = false): void {
    console.log('🔄 Iniciando carga de todas las áreas...');
    // Mostrar loader inmediatamente si se solicita para evitar parpadeos
    if (showLoader) {
      try {
        this.showGlobalLoader();
      } catch {}
    }
    // Evitar duplicados: limpiar capas actuales antes de recargar desde el backend
    this.clearAreaLayers();
    this.teleService.getAllAreas().subscribe({
      next: areas => {
        console.log('� Áreas recibidas directamente:', areas);
        console.log('📍 Número de áreas:', areas?.length || 0);

        if (areas && areas.length > 0) {
          console.log('✅ Mostrando áreas en el mapa...');
          this.displayAreasOnMap(areas);
        } else {
          console.warn('⚠️ No hay áreas para mostrar en el mapa');
        }

        // Lógica de centrado para usuarios SAAS (company_id = 1)
        if (this.companyId() === 1) {
          setTimeout(() => {
            const map = this.myMap();
            if (map) {
              map.invalidateSize(); // Asegurar que el mapa conoce su tamaño real

              if (areas && areas.length > 0) {
                // 1. Centrar en las áreas creadas
                const layers = this.areaLayers.map(al => al.layer);
                if (layers.length > 0) {
                  const group = L.featureGroup(layers);
                  const bounds = group.getBounds();
                  if (bounds.isValid()) {
                    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 18 });
                  }
                }
              } else {
                // 2. Centrar en el polígono delimitado
                const polygon = this.area_geojson();
                if (polygon) {
                  const layer = L.geoJSON(polygon);
                  const bounds = layer.getBounds();
                  if (bounds.isValid()) {
                    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 18 });
                  }
                }
              }
            }
          }, 200); // Pequeño retardo para asegurar renderizado
        }
      },
      error: error => {
        console.error('❌ Error al cargar áreas:', error);
        if (showLoader) {
          try {
            this.hideGlobalLoader();
          } catch {}
        }
      },
      complete: () => {
        // Ocultar loader si lo mostramos explícitamente
        if (showLoader) {
          try {
            this.hideGlobalLoader();
          } catch {}
        }
      },
    });
  }

  /**
   * Mostrar las áreas en el mapa
   */
  private displayAreasOnMap(areas: TeledeteccionArea[]): void {
    console.log('🗺️ Iniciando displayAreasOnMap con', areas.length, 'áreas');

    // Actualizar el array de búsqueda con las áreas
    const searchItems: SearchItem[] = areas.map(area => ({
      id: area.id!,
      name: area.name,
      type: 'area',
    }));
    this.searchAreas.set(searchItems);

    areas.forEach((area, index) => {
      console.log(`🗺️ Procesando área ${index + 1}:`, area);

      if (area.geojson) {
        try {
          // Evitar duplicados: si ya existe una capa con el mismo ID, eliminarla primero
          try {
            const existingIdx = this.areaLayers.findIndex(
              al => al.id === area.id
            );
            if (existingIdx !== -1) {
              const existing = this.areaLayers[existingIdx];
              if (this.myMap()?.hasLayer(existing.layer)) {
                this.myMap().removeLayer(existing.layer);
              }
              this.areaLayers.splice(existingIdx, 1);
            }
          } catch {}

          // Procesar el geojson - puede venir como string o como objeto
          let geoJsonObject;

          if (typeof area.geojson === 'string') {
            console.log(
              `🔧 GeoJSON es string, parseando para área ${area.name}`
            );
            try {
              geoJsonObject = JSON.parse(area.geojson);
            } catch (parseError) {
              console.error('❌ Error al parsear GeoJSON string:', parseError);
              throw new Error(`GeoJSON string inválido para área ${area.name}`);
            }
          } else {
            geoJsonObject = area.geojson;
          }

          // Convertir el geojson al formato correcto para Leaflet
          let validGeoJson;

          // Si el geojson es solo una geometría, convertirlo a Feature
          if (
            geoJsonObject.type &&
            geoJsonObject.type !== 'Feature' &&
            geoJsonObject.type !== 'FeatureCollection'
          ) {
            validGeoJson = {
              type: 'Feature',
              geometry: geoJsonObject,
              properties: {
                id: area.id,
                name: area.name,
                crop: area.crop,
                comment: area.comment,
                community_id: area.community_id,
              },
            };
          } else {
            // Ya es un Feature o FeatureCollection válido
            validGeoJson = geoJsonObject;
          }

          // Validar que el GeoJSON tiene la estructura mínima
          if (!validGeoJson || !validGeoJson.type) {
            throw new Error(
              `GeoJSON no tiene tipo válido para área ${area.name}`
            );
          }

          if (validGeoJson.type === 'Feature' && !validGeoJson.geometry) {
            throw new Error(
              `Feature no tiene geometría para área ${area.name}`
            );
          }

          // Crear la capa GeoJSON para mostrar en el mapa
          const geoJsonLayer = L.geoJSON(validGeoJson, {
            style: {
              fillColor: 'rgba(223, 123, 0, 0.5)',
              fillOpacity: 1,
              color: 'white',
              weight: 2.5,
              opacity: 1,
            },
            onEachFeature: (feature, layer) => {
              // Añadir popup con información del área
              const areaId = area.id || 0;
              console.log(
                '🏷️ Creando popup para área:',
                area.name,
                'con ID:',
                areaId
              );

              layer.on('click', () => {
                this.myMap()?.setView(layer.getBounds().getCenter(), 17);
                // Marcar esta área como seleccionada para que los cambios de filtros recalculen sólo esta
                this.selectedArea.set(area);
                this.areaInfoExpanded.set(true);
                if (!this.showAreaInfo()) this.showAreaInfo.set(true);
                this.showHistoricChart.set(false); // Resetear el histórico al cambiar de área
                this.getIndexImageForSelectedArea(layer);
              });

              // Agregar event listener cuando se abra el popup
              layer.on('popupopen', () => {
                setTimeout(() => {
                  const deleteBtn = document.getElementById(
                    `delete-area-${areaId}`
                  );
                  if (deleteBtn) {
                    deleteBtn.addEventListener('click', () => {
                      console.log(
                        '🖱️ Click en botón eliminar para área ID:',
                        areaId
                      );
                      this.deleteArea(areaId);
                    });
                  }
                }, 100);
              });
            },
          });

          // Añadir la capa al mapa
          const map = this.myMap();
          if (map) {
            geoJsonLayer.addTo(map);
          } else {
            console.error('❌ No hay mapa disponible para añadir área');
          }

          // Guardar referencia para poder eliminarla después si es necesario
          this.areaLayers.push({
            id: area.id!,
            layer: geoJsonLayer,
            area: area,
          });
        } catch (error) {
          console.error('❌ Error al mostrar área en mapa:', area.name, error);
          console.error('❌ GeoJSON problemático:', area.geojson);
        }
      } else {
        console.warn(`⚠️ Área ${area.name} no tiene geojson`);
      }
    });

    console.log(
      `🗺️ Finalizado displayAreasOnMap. Total de capas: ${this.areaLayers.length}`
    );
    // Alinear estilos de áreas con overlays activos tras re-renderizar
    try {
      this.recomputeAreaStyles();
      this.updateSelectedAreaBorder();
    } catch {}
  }

  /**
   * Establecer el área que se está dibujando para crear
   */
  private setCreatingArea(geojson: AreaGeometry): void {
    this.teleService.setCreatingArea(geojson);
  }

  /**
   * Manejar cuando se crea una nueva área
   */
  onAreaCreated(newArea: TeledeteccionArea | undefined): void {
    console.log('🎉 Nueva área creada:', newArea);
    // Mostrar loader global para evitar parpadeo durante la actualización de capas
    try {
      this.showGlobalLoader();
    } catch {}

    // Obtener los valores seleccionados de los chips
    const selectedIndice = this.getSelectedIndice();
    const selectedEscala = this.getSelectedEscala();
    if (selectedIndice && newArea) {
      // Aquí pongo la lógica de teledetección con el índice seleccionado
    }

    // Validar que el área existe
    if (!newArea) {
      console.error('❌ Error: newArea es undefined o null');

      // Refrescar la lista de áreas para obtener la última información
      // ya que el área pudo haberse creado en el backend pero no se devolvió
      console.log('🔄 Refrescando lista de áreas...');
      this.loadAllAreas(true);
      return;
    }

    // Añadir la nueva área al mapa (si viene en la respuesta) o recargar todo mostrando loader
    if (newArea.geojson) {
      this.displayAreasOnMap([newArea]);
      // Ocultar loader tras pintar la nueva área
      try {
        this.hideGlobalLoader();
      } catch {}
    } else {
      // Si no viene la geometría, recargar todo con loader gestionado internamente
      this.loadAllAreas(true);
    }

    // Limpiar cualquier dibujo temporal del mapa
    this.clearTemporaryDrawings();
  }

  /**
   * Limpiar dibujos temporales del mapa
   */
  private clearTemporaryDrawings(): void {
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }
  }

  /**
   * Refrescar todas las áreas en el mapa
   */
  refreshAreasOnMap(): void {
    // Limpiar capas existentes
    this.clearAreaLayers();

    // Recargar áreas
    this.loadAllAreas();
  }

  /**
   * Limpiar todas las capas de áreas del mapa
   */
  private clearAreaLayers(): void {
    const map = this.myMap();
    if (this.areaLayers && map) {
      this.areaLayers.forEach(areaLayer => {
        map.removeLayer(areaLayer.layer);
      });
      this.areaLayers = [];
    }
  }

  /**
   * Eliminar un área específica
   */
  deleteArea(areaId: number): void {
    console.log('🗑️ Iniciando eliminación de área con ID:', areaId);

    if (!areaId || areaId <= 0) {
      console.error('❌ ID de área inválido:', areaId);
      alert('Error: ID de área inválido');
      return;
    }

    if (confirm('¿Estás seguro de que quieres eliminar esta área?')) {
      console.log('✅ Usuario confirmó eliminación');
      this.teleService.deleteArea(areaId).subscribe({
        next: response => {
          console.log('✅ Área eliminada exitosamente:', response);
          // Si el área eliminada es la actualmente seleccionada, limpiar selección y overlays
          if (this.selectedArea()?.id === areaId) {
            try {
              this.onCloseAreaInfo();
            } catch {}
          }
          // Limpiar overlays residuales del área (si hubiera) por seguridad
          try {
            this.clearOverlaysForArea(areaId);
          } catch {}
          // Refrescar todas las áreas mostrando loader para evitar parpadeos
          this.loadAllAreas(true);
        },
        error: error => {
          console.error('❌ Error al eliminar área:', error);
          alert('Error al eliminar el área. Por favor, inténtalo de nuevo.');
          try {
            // Asegurar ocultar loader si estaba visible por cualquier motivo
            this.hideGlobalLoader();
          } catch {}
        },
      });
    } else {
      console.log('🚫 Usuario canceló eliminación');
    }
  }

  /**
   * Remover una capa específica del mapa por ID
   */
  private removeAreaLayerById(areaId: number): void {
    const map = this.myMap();
    if (this.areaLayers && map) {
      const areaLayerIndex = this.areaLayers.findIndex(al => al.id === areaId);
      if (areaLayerIndex !== -1) {
        map.removeLayer(this.areaLayers[areaLayerIndex].layer);
        this.areaLayers.splice(areaLayerIndex, 1);
      }
    }
  }

  /**
   * Devuelve la rampa de color adecuada según el índice seleccionado
   */
  getColorRamp(formGroup: FormGroup): string[] {
    const selected = formGroup?.controls['indice']?.value;
    if (!selected) return COLOR_RAMPS['RdYlGn']; // fallback
    const rampKey = INDEX_TO_RAMP[selected.value] || 'RdYlGn';
    return COLOR_RAMPS[rampKey];
  }

  onModoComparationClick(event: any): void {
    // Debounce para evitar carreras de montaje/desmontaje
    if (this.comparationToggleLock) return;
    this.comparationToggleLock = true;
    setTimeout(
      () => (this.comparationToggleLock = false),
      this.COMPARISON_TOGGLE_DEBOUNCE_MS
    );

    const isActivatingComparison = !this.showMenuComparacion();

    this.showSecondScale.update(value => !value);
    this.showMenuComparacion.update(value => !value);

    // Cuando se activa el modo comparación
    if (isActivatingComparison) {
      // Guardar el estado actual del primaryFilterFormGroup
      this.saveOriginalPrimaryFormState();
      // Inicializar leftFilterFormGroup y rightFilterFormGroup
      this.syncComparisonFormsWithPrimary();

      // Ocultar el primaryLayerGroup durante la comparación
      const map = this.myMap();
      if (map) {
        try {
          (map as any).removeLayer(this.primaryLayerGroup());
        } catch {}
      }
      // Asegurar que las bases de comparación están añadidas al mapa y el control conoce las capas
      this.ensureBasesForComparison();
      this.updateSplitMapLayers();
      // Si hay un área ya seleccionada, dibujar inmediatamente ambos lados
      const sel = this.selectedArea();
      if (sel?.id) {
        this.requestAndRenderIndexForArea(sel.id, 'left');
        this.requestAndRenderIndexForArea(sel.id, 'right');
      }
      // El plugin gestiona el redimensionado del divisor
    } else {
      // Cuando se desactiva el modo comparación, ejecutar la lógica de limpieza
      this.cleanupComparisonMode();
    }
    // signals update UI automáticamente
  }

  /**
   * Guardar el estado actual del primaryFilterFormGroup
   */
  private saveOriginalPrimaryFormState(): void {
    const primaryForm = this.primaryFilterFormGroup();
    if (!primaryForm) return;

    this.originalPrimaryFormState.set({
      indice: primaryForm.controls['indice'].value,
      escala: primaryForm.controls['escala'].value,
      escala_min: primaryForm.controls['escala_min'].value,
      escala_max: primaryForm.controls['escala_max'].value,
      fecha: primaryForm.controls['fecha'].value,
    });
  }

  /**
   * Sincronizar leftFilterFormGroup y rightFilterFormGroup con los valores del primaryFilterFormGroup
   */
  private syncComparisonFormsWithPrimary(): void {
    const primaryForm = this.primaryFilterFormGroup();
    if (!primaryForm) return;

    console.log(
      '🔧 Sincronizando formularios de comparación con valores principales:',
      {
        indice: primaryForm.controls['indice'].value,
        escala: primaryForm.controls['escala'].value,
        escala_min: primaryForm.controls['escala_min'].value,
        escala_max: primaryForm.controls['escala_max'].value,
        fecha: primaryForm.controls['fecha'].value,
      }
    );

    // Crear el formulario para el lado izquierdo (copia del primary)
    const clone = <T>(v: T): T => {
      try {
        return structuredClone
          ? structuredClone(v)
          : JSON.parse(JSON.stringify(v));
      } catch {
        return JSON.parse(JSON.stringify(v));
      }
    };

    const leftForm = this.fb.group({
      indice: [
        clone(primaryForm.controls['indice'].value) ||
          this.indicesVegetacion[0],
      ],
      escala: [clone(primaryForm.controls['escala'].value) || this.escalas[0]],
      escala_min: [primaryForm.controls['escala_min'].value || -1],
      escala_max: [primaryForm.controls['escala_max'].value || 1],
      fecha: [primaryForm.controls['fecha'].value || null],
    });

    const rightForm = this.fb.group({
      indice: [
        clone(primaryForm.controls['indice'].value) ||
          this.indicesVegetacion[0],
      ],
      escala: [clone(primaryForm.controls['escala'].value) || this.escalas[0]],
      escala_min: [primaryForm.controls['escala_min'].value || -1],
      escala_max: [primaryForm.controls['escala_max'].value || 1],
      fecha: [primaryForm.controls['fecha'].value || null],
    });

    this.leftFilterFormGroup.set(leftForm);
    this.rightFilterFormGroup.set(rightForm);
    console.log('✅ Formularios de comparación creados:', {
      left: leftForm.value,
      right: rightForm.value,
    });
    // Forzar la detección de cambios antes de actualizar el componente hijo
    // signals update UI automáticamente

    // (Re) suscribirse a cambios en formularios de comparación
    this.subscribeToComparisonFormChanges();

    // Actualizar los formularios en el componente hijo si está disponible
    setTimeout(() => {
      if (this.menuComparacion) {
        console.log('🔧 Actualizando formularios en el componente hijo...');
        this.menuComparacion.updateLeftForm(leftForm.value);
        this.menuComparacion.updateRightForm(rightForm.value);
        console.log('✅ Formularios del componente hijo actualizados');
      }
    }, 0);
  }

  onClickCloseMenuComparacion(event: any): void {
    this.showSecondScale.set(false);
    this.showMenuComparacion.set(false);

    // Ejecutar la lógica de limpieza común
    this.cleanupComparisonMode();
  }

  /**
   * Lógica de limpieza del modo comparación (sin actualizar señales)
   */
  private cleanupComparisonMode(): void {
    // Cerrar el popup de información del área si está abierto
    this.onCloseAreaInfo();

    // Remover el control split ANTES de tocar capas para evitar eventos del slider sobre capas sin mapa
    try {
      if (this.splitMapControl && this.myMap()) {
        this.myMap().removeControl(this.splitMapControl);
      }
    } catch {}
    this.splitMapControl = null;
    this.splitMapActive = false;
    this.unbindSplitOverlayPaneClipping();

    // Restaurar el estado original del primaryFilterFormGroup
    this.restoreOriginalPrimaryFormState();

    // Cancelar suscripciones específicas de comparación
    if (this.leftFormSub) {
      this.leftFormSub.unsubscribe();
      this.leftFormSub = undefined;
    }
    if (this.rightFormSub) {
      this.rightFormSub.unsubscribe();
      this.rightFormSub = undefined;
    }

    // Limpiar overlays (no vaciamos bases mientras split estuvo activo)
    this.clearOverlaysForSide('left');
    this.clearOverlaysForSide('right');
    this.leftFilterFormGroup.set(null);
    this.rightFilterFormGroup.set(null);

    // Limpiar el estado original guardado
    this.originalPrimaryFormState.set(null);

    // Volver a mostrar el primaryLayerGroup y recalcular según primary
    const map = this.myMap();
    if (map) {
      try {
        this.primaryLayerGroup().addTo(map);
      } catch {}
    }
    const primary = this.primaryFilterFormGroup();
    const pDate = extractDateString(primary?.value?.fecha);
    const pIndex = extractIndiceValue(primary?.value?.indice);
    if (pDate && pIndex) {
      // Limpiar overlays previos del primary antes de recalcular
      this.clearOverlaysForSide('primary');
    }
  }

  /**
   * Restaurar el estado original del primaryFilterFormGroup
   */
  private restoreOriginalPrimaryFormState(): void {
    const originalState = this.originalPrimaryFormState();
    const primaryForm = this.primaryFilterFormGroup();

    if (!originalState || !primaryForm) return;

    // Restaurar los valores sin emitir eventos para evitar bucles
    primaryForm.patchValue(originalState, { emitEvent: false });
  }

  /**
   * Suscribirse a cambios en left/right para disparar calculateIndex
   */
  private subscribeToComparisonFormChanges(): void {
    // Limpiar suscripciones previas si existen
    if (this.leftFormSub) {
      this.leftFormSub.unsubscribe();
      this.leftFormSub = undefined;
    }
    if (this.rightFormSub) {
      this.rightFormSub.unsubscribe();
      this.rightFormSub = undefined;
    }

    const left = this.leftFilterFormGroup();
    if (left) {
      this.leftFormSub = left.valueChanges
        .pipe(
          map(v => ({
            fecha: v?.fecha,
            indice: v?.indice,
            escala: v?.escala?.value,
          })),
          debounceTime(300),
          distinctUntilChanged(
            (a, b) =>
              (extractDateString(a.fecha) || null) ===
                (extractDateString(b.fecha) || null) &&
              (extractIndiceValue(a.indice) || null) ===
                (extractIndiceValue(b.indice) || null) &&
              (a?.escala ?? null) === (b?.escala ?? null)
          ),
          filter(
            v => !!extractDateString(v.fecha) && !!extractIndiceValue(v.indice)
          )
        )
        .subscribe(v => {
          // Actualizar overlays existentes en el lado izquierdo según nuevos filtros
          const selectedId = this.selectedArea()?.id;
          if (selectedId != null) {
            this.requestAndRenderIndexForArea(selectedId, 'left');
          }
          // También refrescar cualquier overlay ya visible para mantener consistencia
          this.overlaysBySide.left.forEach((_, id) => {
            this.requestAndRenderIndexForArea(id, 'left');
          });
        });
      this.subscriptions.push(this.leftFormSub);
    }

    const right = this.rightFilterFormGroup();
    if (right) {
      this.rightFormSub = right.valueChanges
        .pipe(
          map(v => ({
            fecha: v?.fecha,
            indice: v?.indice,
            escala: v?.escala?.value,
          })),
          debounceTime(300),
          distinctUntilChanged(
            (a, b) =>
              (extractDateString(a.fecha) || null) ===
                (extractDateString(b.fecha) || null) &&
              (extractIndiceValue(a.indice) || null) ===
                (extractIndiceValue(b.indice) || null) &&
              (a?.escala ?? null) === (b?.escala ?? null)
          ),
          filter(
            v => !!extractDateString(v.fecha) && !!extractIndiceValue(v.indice)
          )
        )
        .subscribe(v => {
          // Actualizar overlays existentes en el lado derecho según nuevos filtros
          const selectedId = this.selectedArea()?.id;
          if (selectedId != null) {
            this.requestAndRenderIndexForArea(selectedId, 'right');
          }
          // También refrescar cualquier overlay ya visible en el lado derecho
          this.overlaysBySide.right.forEach((_, id) => {
            this.requestAndRenderIndexForArea(id, 'right');
          });
        });
      this.subscriptions.push(this.rightFormSub);
    }
  }

  /**
   * Normaliza el valor de fecha a 'YYYY-MM-DD'
   */
  private extractDateString(fecha: any): string | null {
    if (!fecha) return null;
    try {
      if (typeof fecha === 'string') {
        // Asumimos que ya viene formateada
        return fecha.length >= 10 ? fecha.substring(0, 10) : fecha;
      }
      if (fecha instanceof Date) {
        return fecha.toISOString().slice(0, 10);
      }
      // Algunos datepickers emiten objetos con 'toDate' o similares
      if (fecha?.toDate) {
        return new Date(fecha.toDate()).toISOString().slice(0, 10);
      }
      // Intento final
      return new Date(fecha).toISOString().slice(0, 10);
    } catch {
      return null;
    }
  }

  /**
   * Extrae el nombre/código del índice desde el control (objeto o string)
   */
  private extractIndiceValue(indice: any): string | null {
    if (!indice) return null;
    if (typeof indice === 'string') return indice;
    return indice?.value ?? null;
  }

  private getCachedIndexRequest(
    areaId: number,
    dateStr: string,
    indexName: string
  ) {
    this.isLoadingAreaData.set(true);
    const key = `${dateStr}|${indexName}|${areaId}`;
    const existing = this.indexRequestCache.get(key);
    if (existing) return existing;
    const obs = this.teleService
      .calculateIndex({ date: dateStr, area_id: areaId, index_name: indexName })
      .pipe(
        shareReplay(1),
        finalize(() => this.isLoadingAreaData.set(false))
      );
    // Evitar crecimiento ilimitado
    if (this.indexRequestCache.size > this.INDEX_CACHE_MAX) {
      // eliminar la primera clave insertada (no ordenado garantizado, pero suficiente)
      const firstKey = this.indexRequestCache.keys().next().value;
      this.indexRequestCache.delete(firstKey);
    }
    this.indexRequestCache.set(key, obs);

    return obs;
  }

  /**
   * Solicita (usando caché) y pinta el overlay para un área y lado concretos
   */
  private requestAndRenderIndexForArea(
    areaId: number,
    side: 'primary' | 'left' | 'right'
  ): void {
    const form =
      side === 'primary'
        ? this.primaryFilterFormGroup()
        : side === 'left'
          ? this.leftFilterFormGroup()
          : this.rightFilterFormGroup();

    const dateStr = extractDateString(form?.value?.fecha);
    const indexName = extractIndiceValue(form?.value?.indice);
    if (!dateStr || !indexName) return;

    const escalaType = this.getEscalaValue(side);
    const currentKey = `${dateStr}|${indexName}|${escalaType}|${areaId}`;
    const lastKey = this.lastParamsBySide[side].get(areaId);
    if (lastKey === currentKey && this.overlaysBySide[side].has(areaId)) {
      return; // sin cambios
    }

    const obs = this.getCachedIndexRequest(areaId, dateStr, indexName);
    this.lastParamsBySide[side].set(areaId, currentKey);
    obs.subscribe({
      next: resp => {
        try {
          this.addOrUpdateImageOverlayForArea(areaId, resp, side, indexName);
        } catch (e) {
          console.error('❌ Error aplicando overlay al área', areaId, e);
        }
      },
      error: err => {
        console.error('❌ Error en calculateIndex (requestAndRender)', err);

        // Manejar errores específicos del backend cuando no hay imágenes disponibles
        const errorDetail = err?.error?.detail || err?.detail;
        if (errorDetail && typeof errorDetail === 'string') {
          // Limpiar overlay existente para el área (ponerla en gris)
          const sideMap = this.overlaysBySide[side];
          const existing = sideMap.get(areaId);
          if (existing) {
            try {
              this.removeOverlay(existing, side);
            } catch {}
            sideMap.delete(areaId);
            this.recomputeAreaStyles();
          }

          // Mostrar mensaje de error si es el área seleccionada
          if (this.selectedArea()?.id === areaId) {
            this.bottomMessage.set(errorDetail);
            this.showBottomMessageIcon.set(true);
            this.showBottomMessage.set(true);
          }
        }
      },
    });
  }

  /**
   * Crea o actualiza un ImageOverlay con la imagen base64 sobre el bbox del área
   */
  private addOrUpdateImageOverlayForArea(
    areaId: number,
    data: any,
    side: 'primary' | 'left' | 'right',
    indexName: string,
    errorMessage?: string
  ): void {
    if (!data) return;
    const base64: string | undefined = data.image_base64;
    if (!base64) {
      // Si no hay imagen, limpiar overlay previo (si lo hubiera) y mostrar mensaje si es el área seleccionada
      const sideMap = this.overlaysBySide[side];
      const existing = sideMap.get(areaId);
      if (existing) {
        try {
          this.removeOverlay(existing, side);
        } catch {}
        sideMap.delete(areaId);
        this.recomputeAreaStyles();
      }
      if (this.selectedArea()?.id === areaId) {
        const message =
          errorMessage ||
          data?.detail ||
          'No se encuentran datos para los filtros seleccionados';
        this.bottomMessage.set(message);
        this.showBottomMessageIcon.set(true);
        this.showBottomMessage.set(true);
      }
      return;
    }

    const map = this.myMap();
    if (!map) return;

    const bounds = computeBoundsFromResponse(data);
    if (!bounds) return;

    // Escala (min/max): si escala específica, usar min/max del response; si no, usar valores del formulario
    let { min, max } = this.getScaleRange(side);
    const escalaVal = this.getEscalaValue(side);
    if (escalaVal === 'especifica') {
      const respMin = Number((data as any)?.min_value);
      const respMax = Number((data as any)?.max_value);
      if (Number.isFinite(respMin) && Number.isFinite(respMax)) {
        min = respMin;
        max = respMax;
      }
    }

    // Para "Imagen real" (VISIBLE), no aplicar rampa de color
    let colorFn: ((val: number[] | number) => string | null) | undefined;
    if (indexName !== 'VISIBLE') {
      const ramp =
        getColorRampForIndexName(indexName, true) || COLOR_RAMPS['RdYlGn'];
      colorFn = buildColorFn(ramp, min, max);
    }

    // Si existe overlay previo lo eliminamos para evitar inconsistencias
    const sideMap = this.overlaysBySide[side];
    const existing = sideMap.get(areaId);
    if (existing) {
      try {
        this.removeOverlay(existing, side);
      } catch {}
      sideMap.delete(areaId);
    }

    // Registrar la fecha de la imagen para el área y lado (PNG o GeoTIFF)
    const imageDate = (data as any)?.image_date as string | undefined;
    if (imageDate) {
      this.lastImageDateBySide[side].set(areaId, imageDate);
      this.imageDateVersion.update(v => v + 1);
    }

    const isTiff =
      base64.startsWith('data:image/tiff') ||
      base64.startsWith('data:image/tif');
    // Pane por lado (para que el plugin pueda recortar sin afectar a todo overlayPane)
    const paneName =
      side === 'left'
        ? 'split-left'
        : side === 'right'
          ? 'split-right'
          : 'default-pane';

    // Si estamos en modo normal (side === 'primary'), asegurar el pane con blur
    if (paneName === 'default-pane') this.defaultPaneBlur();

    if (!isTiff) {
      // Fallback PNG/JPEG
      const overlayOptions: any = {
        opacity: 0.85,
        interactive: false,
        zIndex: 450,
        ...(paneName ? { pane: paneName } : {}),
      };
      const overlay = L.imageOverlay(base64, bounds, overlayOptions);
      this.addOverlayToSide(overlay, side);
      sideMap.set(areaId, overlay);
      this.recomputeAreaStyles();
      this.updateSelectedAreaBorder();
      // Ocultar mensaje de error si corresponde al área seleccionada
      if (this.selectedArea()?.id === areaId) {
        this.showBottomMessage.set(false);
      }
      // signals update UI automatically
      return;
    }

    // Registrar min/max de backend si escala específica para uso en leyenda
    if (this.getEscalaValue(side) === 'especifica') {
      const respMin = Number((data as any)?.min_value);
      const respMax = Number((data as any)?.max_value);
      if (Number.isFinite(respMin) && Number.isFinite(respMax)) {
        this.lastMinMaxBySide[side].set(areaId, { min: respMin, max: respMax });
      }
    }

    // Obtener el GeoJSON del área para recortar la imagen (solo para VISIBLE/Imagen real)
    let maskGeojson: any = undefined;
    if (indexName === 'VISIBLE') {
      const areaEntry = this.areaLayers.find(a => a.id === areaId);
      if (areaEntry?.area?.geojson) {
        try {
          let geojsonObj: any = areaEntry.area.geojson;
          // Si el geojson es string, parsearlo
          if (typeof geojsonObj === 'string') {
            geojsonObj = JSON.parse(geojsonObj);
          }
          // Asegurarse de que es un Feature o FeatureCollection válido
          if (
            geojsonObj.type === 'Feature' ||
            geojsonObj.type === 'FeatureCollection'
          ) {
            maskGeojson = geojsonObj;
          } else if (
            geojsonObj.type === 'Polygon' ||
            geojsonObj.type === 'MultiPolygon'
          ) {
            // Si es solo la geometría, envolverla en un Feature
            maskGeojson = {
              type: 'Feature',
              geometry: geojsonObj,
              properties: {},
            };
          }
          console.log(
            '🎭 Máscara GeoJSON preparada para VISIBLE:',
            maskGeojson
          );
        } catch (e) {
          console.warn('⚠️ No se pudo procesar el GeoJSON para máscara', e);
        }
      } else {
        console.warn('⚠️ No se encontró GeoJSON para el área', areaId);
      }
    }

    // Procesar GeoTIFF async
    createGeoRasterLayerFromBase64(
      base64,
      bounds,
      colorFn,
      paneName ? { pane: paneName, zIndex: 450 } : undefined,
      maskGeojson
      // { pane: paneName, zIndex: 450 }
    ).then(layer => {
      if (!layer) return;
      this.addOverlayToSide(layer, side);
      sideMap.set(areaId, layer);
      recomputeAreaStylesUtil(this.areaLayers, this.overlaysBySide as any);
      this.updateSelectedAreaBorder();
      // Ocultar mensaje de error si corresponde al área seleccionada
      if (this.selectedArea()?.id === areaId) {
        this.showBottomMessage.set(false);
      }
    });
  }

  /**
   * Hacer blur en el pane por default cuando no está en modo comparación
   */
  private defaultPaneBlur(): void {
    try {
      const map = this.myMap();
      if (!map) return;
      const paneName = 'default-pane';
      let pane = map.getPane(paneName);
      if (!pane) {
        pane = map.createPane(paneName);
        // Similar prioridad a los overlays de comparación
        pane.style.zIndex = '450';
      }
      // Aplicar estilos (idempotente)
      this.processImageBlur(pane, 'primary');
    } catch {}
  }

  private addOverlayToSide(layer: L.Layer, side: 'primary' | 'left' | 'right') {
    const targetGroup = this.getTargetLayerGroupForSide(side);
    // En modo comparación, añadir overlays directamente al mapa y actualizar capas del split
    if (this.splitMapActive && (side === 'left' || side === 'right')) {
      const map = this.myMap();
      if (map && !map.hasLayer(layer)) map.addLayer(layer);
      (layer as any).bringToFront?.();
      this.updateSplitMapLayers();
      return;
    }
    // Modo normal o lado primary
    if (targetGroup) targetGroup.addLayer(layer);
    else this.myMap()?.addLayer(layer);
    (layer as any).bringToFront?.();
    try {
      console.log(
        '[Overlay] Añadido overlay para lado',
        side,
        'capas en left:',
        this.leftLayerGroup().getLayers().length,
        'right:',
        this.rightLayerGroup().getLayers().length
      );
    } catch {}
  }

  private removeOverlay(layer: L.Layer, side: 'primary' | 'left' | 'right') {
    const targetGroup = this.getTargetLayerGroupForSide(side);
    try {
      if (this.splitMapActive && (side === 'left' || side === 'right')) {
        if (this.myMap()?.hasLayer(layer)) this.myMap().removeLayer(layer);
        this.updateSplitMapLayers();
        return;
      }
      if (targetGroup && (targetGroup as any).hasLayer(layer)) {
        targetGroup.removeLayer(layer);
      } else {
        this.myMap()?.removeLayer(layer);
      }
    } catch {}
  }

  private getScaleRange(side: 'primary' | 'left' | 'right'): {
    min: number;
    max: number;
  } {
    const form =
      side === 'primary'
        ? this.primaryFilterFormGroup()
        : side === 'left'
          ? this.leftFilterFormGroup()
          : this.rightFilterFormGroup();
    return getScaleRangeFromForm(form, { min: -1, max: 1 });
  }

  private getEscalaValue(
    side: 'primary' | 'left' | 'right'
  ): 'general' | 'especifica' {
    const form =
      side === 'primary'
        ? this.primaryFilterFormGroup()
        : side === 'left'
          ? this.leftFilterFormGroup()
          : this.rightFilterFormGroup();
    return getEscalaTypeFromForm(form);
  }

  private getTargetLayerGroupForSide(
    side: 'primary' | 'left' | 'right'
  ): L.LayerGroup | null {
    if (side === 'left') return this.leftLayerGroup();
    if (side === 'right') return this.rightLayerGroup();
    return this.primaryLayerGroup();
  }

  /**
   * Limpiar y remover overlays de un lado específico
   */
  private clearOverlaysForSide(side: 'primary' | 'left' | 'right'): void {
    const sideMap = this.overlaysBySide[side];
    const map = this.myMap();
    const group = this.getTargetLayerGroupForSide(side);
    sideMap.forEach(overlay => {
      try {
        if (this.splitMapActive && (side === 'left' || side === 'right')) {
          if (map && map.hasLayer(overlay)) map.removeLayer(overlay);
        } else if (group && (group as any).hasLayer(overlay)) {
          group.removeLayer(overlay);
        } else if (map && map.hasLayer(overlay)) {
          map.removeLayer(overlay);
        }
      } catch {}
    });
    sideMap.clear();
    // También limpiar las últimas claves para forzar recalculado posterior
    this.lastParamsBySide[side].clear();
    // Limpiar min/max almacenados para este lado
    this.lastMinMaxBySide[side].clear();
    // Limpiar última fecha de imagen para este lado
    this.lastImageDateBySide[side].clear();
    this.imageDateVersion.update(v => v + 1);
    this.recomputeAreaStyles();
    this.updateSelectedAreaBorder();
  }

  /**
   * Elimina cualquier overlay activo asociado a un área concreta (en los tres lados)
   */
  private clearOverlaysForArea(areaId: number): void {
    (['primary', 'left', 'right'] as const).forEach(side => {
      const overlay = this.overlaysBySide[side].get(areaId);
      if (overlay) {
        try {
          this.removeOverlay(overlay, side);
        } catch {}
        this.overlaysBySide[side].delete(areaId);
      }
      // Limpiar meta-información ligada a ese área
      this.lastParamsBySide[side].delete(areaId);
      this.lastMinMaxBySide[side].delete(areaId);
      this.lastImageDateBySide[side].delete(areaId);
    });
    this.imageDateVersion.update(v => v + 1);
    this.updateSelectedAreaBorder();
  }

  /**
   * Oculta el estilo azul de áreas que tienen overlay activo para no contaminar colores del índice.
   */
  private recomputeAreaStyles(): void {
    const activeIds = new Set<number>();
    Object.values(this.overlaysBySide).forEach(m =>
      m.forEach((_, id) => activeIds.add(id))
    );
    // Mantener el estilo gris definido originalmente en displayAreasOnMap
    const defaultStyle = {
      color: '#FFFFFF',
      weight: 2.5,
      opacity: 1,
      fillOpacity: 0.8,
    };
    const hiddenStyle = {
      color: 'transparent',
      weight: 0,
      opacity: 0,
      fillOpacity: 0,
    } as any;
    this.areaLayers.forEach(a => {
      try {
        a.layer.setStyle(activeIds.has(a.id) ? hiddenStyle : defaultStyle);
      } catch {}
    });
  }

  /**
   * Obtener el FormGroup correcto según el contexto y la posición
   */
  private getCurrentFormGroup(side: 'left' | 'right'): FormGroup | null {
    // En modo comparación
    if (this.showMenuComparacion()) {
      return side === 'left'
        ? this.leftFilterFormGroup()
        : this.rightFilterFormGroup();
    }
    // En modo normal, ambos lados usan el primaryFilterFormGroup
    return this.primaryFilterFormGroup();
  }

  /**
   * Obtener el título de la escala para el lado especificado
   */
  getCurrentScaleTitle(side: 'left' | 'right'): string {
    const formGroup = this.getCurrentFormGroup(side);
    if (!formGroup) return 'Escala General';
    const escalaValue = formGroup.controls['escala']?.value?.value;
    const effectiveSide: 'primary' | 'left' | 'right' =
      this.showMenuComparacion() ? side : 'primary';
    const activeAreaId = this.getActiveAreaIdForSide(effectiveSide);
    const isShowingIndex = activeAreaId != null; // hay overlay activo
    if (escalaValue === 'especifica' && isShowingIndex) {
      return 'Escala Específica';
    }
    return 'Escala General';
  }

  /**
   * Obtener el valor mínimo de la escala para el lado especificado
   */
  getCurrentScaleMin(side: 'left' | 'right'): number {
    const formGroup = this.getCurrentFormGroup(side);

    const effectiveSide: 'primary' | 'left' | 'right' =
      this.showMenuComparacion() ? side : 'primary';
    if (this.getEscalaValue(effectiveSide) === 'especifica') {
      const activeAreaId = this.getActiveAreaIdForSide(effectiveSide);
      const mm =
        activeAreaId != null
          ? this.lastMinMaxBySide[effectiveSide].get(activeAreaId)
          : undefined;
      if (mm && Number.isFinite(mm.min)) return mm.min;
    }
    return formGroup?.controls['escala_min']?.value || -1;
  }

  /**
   * Obtener el valor máximo de la escala para el lado especificado
   */
  getCurrentScaleMax(side: 'left' | 'right'): number {
    const formGroup = this.getCurrentFormGroup(side);

    const effectiveSide: 'primary' | 'left' | 'right' =
      this.showMenuComparacion() ? side : 'primary';
    if (this.getEscalaValue(effectiveSide) === 'especifica') {
      const activeAreaId = this.getActiveAreaIdForSide(effectiveSide);
      const mm =
        activeAreaId != null
          ? this.lastMinMaxBySide[effectiveSide].get(activeAreaId)
          : undefined;
      if (mm && Number.isFinite(mm.max)) return mm.max;
    }
    return formGroup?.controls['escala_max']?.value || 1;
  }

  /** Devuelve el área activa para una leyenda dada: seleccionada si tiene overlay, o la primera con overlay en ese lado */
  private getActiveAreaIdForSide(
    side: 'primary' | 'left' | 'right'
  ): number | null {
    const selId = this.selectedArea()?.id ?? null;
    if (selId != null && this.overlaysBySide[side].has(selId)) return selId;
    const it = this.overlaysBySide[side].keys();
    const next = it.next();
    return next && !next.done ? (next.value as number) : null;
  }

  /**
   * Obtener el color ramp para el lado especificado
   */
  getCurrentColorRamp(side: 'left' | 'right'): any {
    const formGroup = this.getCurrentFormGroup(side);
    return formGroup ? this.getColorRamp(formGroup) : null;
  }

  /**
   * Determina si la escala debe mostrarse deshabilitada (escala de grises con baja opacidad)
   * Esto ocurre cuando está seleccionada la escala específica pero no hay área seleccionada para mostrar índices
   */
  isScaleDisabled(side: 'left' | 'right'): boolean {
    const formGroup = this.getCurrentFormGroup(side);
    if (!formGroup) return false;

    const escalaValue = formGroup.controls['escala']?.value?.value;
    const effectiveSide: 'primary' | 'left' | 'right' =
      this.showMenuComparacion() ? side : 'primary';
    const activeAreaId = this.getActiveAreaIdForSide(effectiveSide);
    const isShowingIndex = activeAreaId != null; // hay overlay activo

    // Si es escala específica pero no hay índice mostrado, está deshabilitada
    return escalaValue === 'especifica' && !isShowingIndex;
  }

  /**
   * Determina si la escala debe ocultarse completamente
   * Esto ocurre cuando el índice seleccionado es 'VISIBLE' (Imagen real)
   */
  shouldHideScale(side: 'left' | 'right'): boolean {
    const formGroup = this.getCurrentFormGroup(side);
    if (!formGroup) return false;

    const indiceValue = extractIndiceValue(formGroup.controls['indice']?.value);
    return indiceValue === 'VISIBLE';
  }

  /** Fecha graficada (image_date) de la última respuesta calculateIndex() para el área seleccionada */
  getPlottedImageDate(): string {
    return this.plottedImageDate();
  }

  /** Obtiene la fecha de la imagen para el lado izquierdo en modo comparación */
  getPlottedImageDateLeft(): string {
    return this.plottedImageDateLeft();
  }

  /** Obtiene la fecha de la imagen para el lado derecho en modo comparación */
  getPlottedImageDateRight(): string {
    return this.plottedImageDateRight();
  }

  /** Verifica si se está mostrando el modo comparación */
  isComparisonMode(): boolean {
    return this.showMenuComparacion();
  }

  /** Verifica si hay overlays activos en ambos lados en modo comparación */
  hasActiveOverlaysInComparison(): boolean {
    const sel = this.selectedArea();
    if (!sel?.id || !this.showMenuComparacion()) return false;

    const hasLeft = this.overlaysBySide.left.has(sel.id);
    const hasRight = this.overlaysBySide.right.has(sel.id);

    return hasLeft || hasRight;
  }

  onChangeLeftForm(event: any): void {
    // No parcheamos silenciosamente: los cambios de FormGroup ya propagan via valueChanges
    console.log('🔧 Cambio en leftForm desde menú comparación:', event);
  }

  onChangeRightForm(event: any): void {
    // No parcheamos silenciosamente: los cambios de FormGroup ya propagan via valueChanges
    console.log('🔧 Cambio en rightForm desde menú comparación:', event);
  }

  // Métodos legacy para compatibilidad temporal
  onChangePrimaryForm(event: any): void {
    this.onChangeLeftForm(event);
  }

  onChangeSecondaryForm(event: any): void {
    this.onChangeRightForm(event);
  }
  // #endregion METODOS DE TELEDETECCION
  // ------------------------------------------

  leafletMouseMove(e) {
    // Throttle: acumula la última posición y actualiza como máximo cada MOUSEMOVE_THROTTLE_MS
    this.mouseMoveLast = { lat: e.latlng.lat, lng: e.latlng.lng };
    if (this.mouseMoveThrottleId) return;

    this.mouseMoveThrottleId = setTimeout(() => {
      this.mouseMoveThrottleId = null;
      const last = this.mouseMoveLast;
      if (!last) return;
      const latStr = last.lat.toFixed(5);
      const lngStr = last.lng.toFixed(5);
      // Evitar sets redundantes
      if (latStr !== this.lat()) this.lat.set(latStr);
      if (lngStr !== this.long()) this.long.set(lngStr);
    }, this.MOUSEMOVE_THROTTLE_MS);
  }

  getIndexImageForSelectedArea(areaLayer: any) {
    try {
      const props = areaLayer?.feature?.properties || {};
      const areaId: number | undefined = props.id ?? props.area_id;
      if (!areaId) {
        console.warn(
          '[Teledetección] No se pudo obtener el ID del área clicada'
        );
        return;
      }

      // Optimización: si ya estamos mostrando el mismo área con los mismos filtros, no recalcular ni limpiar
      if (this.showMenuComparacion()) {
        const leftForm = this.leftFilterFormGroup();
        const rightForm = this.rightFilterFormGroup();
        const leftDate = extractDateString(leftForm?.value?.fecha);
        const leftIndex = extractIndiceValue(leftForm?.value?.indice);
        const rightDate = extractDateString(rightForm?.value?.fecha);
        const rightIndex = extractIndiceValue(rightForm?.value?.indice);
        const leftScale = this.getEscalaValue('left');
        const rightScale = this.getEscalaValue('right');
        const leftKey =
          leftDate && leftIndex
            ? `${leftDate}|${leftIndex}|${leftScale}|${areaId}`
            : null;
        const rightKey =
          rightDate && rightIndex
            ? `${rightDate}|${rightIndex}|${rightScale}|${areaId}`
            : null;
        const leftUpToDate =
          !!leftKey &&
          this.overlaysBySide.left.has(areaId) &&
          this.lastParamsBySide.left.get(areaId) === leftKey;
        const rightUpToDate =
          !!rightKey &&
          this.overlaysBySide.right.has(areaId) &&
          this.lastParamsBySide.right.get(areaId) === rightKey;
        if (leftUpToDate && rightUpToDate) {
          this.updateSelectedAreaBorder();
          return;
        }

        // Limpiar sólo si hay overlays de OTRA área visibles; mantener si ya es la misma área
        const leftHasOther = Array.from(this.overlaysBySide.left.keys()).some(
          id => id !== areaId
        );
        const rightHasOther = Array.from(this.overlaysBySide.right.keys()).some(
          id => id !== areaId
        );
        if (leftHasOther) this.clearOverlaysForSide('left');
        if (rightHasOther) this.clearOverlaysForSide('right');
      } else {
        // Modo normal: evaluar si ya está todo al día para el área actual
        const primary = this.primaryFilterFormGroup();
        const dateStr0 = extractDateString(primary?.value?.fecha);
        const indexName0 = extractIndiceValue(primary?.value?.indice);
        if (!dateStr0 || !indexName0) return;
        const scale0 = this.getEscalaValue('primary');
        const currentKey0 = `${dateStr0}|${indexName0}|${scale0}|${areaId}`;
        const upToDate0 =
          this.overlaysBySide.primary.has(areaId) &&
          this.lastParamsBySide.primary.get(areaId) === currentKey0;
        if (upToDate0) {
          this.updateSelectedAreaBorder();
          return;
        }
        if (upToDate0) {
          this.updateSelectedAreaBorder();
          return;
        }
        // Limpiar sólo si hay overlay de otra área
        const primaryHasOther = Array.from(
          this.overlaysBySide.primary.keys()
        ).some(id => id !== areaId);
        if (primaryHasOther) this.clearOverlaysForSide('primary');
      }

      // En modo comparación, pintar ambos lados con sus filtros (sólo los desactualizados)
      if (this.showMenuComparacion()) {
        (['left', 'right'] as const).forEach(s => {
          const form =
            s === 'left'
              ? this.leftFilterFormGroup()
              : this.rightFilterFormGroup();
          const d = extractDateString(form?.value?.fecha);
          const i = extractIndiceValue(form?.value?.indice);
          if (!d || !i) return;
          const k = `${d}|${i}|${this.getEscalaValue(s)}|${areaId}`;
          const isUpToDate =
            this.overlaysBySide[s].has(areaId) &&
            this.lastParamsBySide[s].get(areaId) === k;
          if (!isUpToDate) this.requestAndRenderIndexForArea(areaId, s);
        });
        return;
      }

      // Modo normal: usar filtros primarios
      const primary = this.primaryFilterFormGroup();
      const dateStr = extractDateString(primary?.value?.fecha);
      const indexName = extractIndiceValue(primary?.value?.indice);
      if (!dateStr || !indexName) {
        console.warn('[Teledetección] Falta fecha o índice seleccionado');
        return;
      }

      const side: 'primary' = 'primary';
      const escalaType = this.getEscalaValue(side);
      const lastKey = this.lastParamsBySide[side].get(areaId);
      const currentKey = `${dateStr}|${indexName}|${escalaType}|${areaId}`;

      if (lastKey === currentKey && this.overlaysBySide[side].has(areaId)) {
        return;
      }

      const obs = this.getCachedIndexRequest(areaId, dateStr, indexName);
      this.lastParamsBySide[side].set(areaId, currentKey);

      obs.subscribe({
        next: resp => {
          try {
            this.addOrUpdateImageOverlayForArea(areaId, resp, side, indexName);
          } catch (e) {
            console.error('❌ Error aplicando overlay al área', areaId, e);
          }
        },
        error: err => {
          console.error('❌ Error en calculateIndex (click área)', err);

          // Manejar errores específicos del backend cuando no hay imágenes disponibles
          const errorDetail = err?.error?.detail || err?.detail;
          if (errorDetail && typeof errorDetail === 'string') {
            // Limpiar overlay existente para el área (ponerla en gris)
            const sideMap = this.overlaysBySide[side];
            const existing = sideMap.get(areaId);
            if (existing) {
              try {
                this.removeOverlay(existing, side);
              } catch {}
              sideMap.delete(areaId);
              this.recomputeAreaStyles();
            }

            // Mostrar mensaje de error si es el área seleccionada
            if (this.selectedArea()?.id === areaId) {
              this.bottomMessage.set(errorDetail);
              this.showBottomMessageIcon.set(true);
              this.showBottomMessage.set(true);
            }
          }
        },
      });
    } catch (e) {
      console.error('[Teledetección] Error procesando click de área', e);
    }
  }

  // ===== Helpers para SplitMap =====
  private ensureBasesForComparison(): void {
    if (!this.myMap()) return;
    if (!this.leftBaseLayer || !this.rightBaseLayer) {
      // Si aún no se generaron, crearlas
      prepareSplitGroups(this.leftLayerGroup(), this.rightLayerGroup(), () =>
        this.mapaService.getLyrGoogleSattellite()
      );
      const leftLayers = this.leftLayerGroup().getLayers?.() || [];
      const rightLayers = this.rightLayerGroup().getLayers?.() || [];
      this.leftBaseLayer =
        leftLayers[0] ?? this.mapaService.getLyrGoogleSattellite();
      this.rightBaseLayer =
        rightLayers[0] ?? this.mapaService.getLyrGoogleSattellite();
    }
    try {
      const map = this.myMap();
      if (map && this.leftBaseLayer && !map.hasLayer(this.leftBaseLayer)) {
        map.addLayer(this.leftBaseLayer);
      }
      if (map && this.rightBaseLayer && !map.hasLayer(this.rightBaseLayer)) {
        map.addLayer(this.rightBaseLayer);
      }
    } catch {}
  }

  private ensureSideLayersOnMap(side: 'left' | 'right'): void {
    const map = this.myMap();
    if (!map) return;
    const overlays = this.overlaysBySide[side];
    overlays.forEach(layer => {
      try {
        if (!map.hasLayer(layer)) map.addLayer(layer);
      } catch {}
    });
  }

  private removeSideLayersFromMap(side: 'left' | 'right'): void {
    const map = this.myMap();
    if (!map) return;
    const overlays = this.overlaysBySide[side];
    overlays.forEach(layer => {
      try {
        if (map.hasLayer(layer)) map.removeLayer(layer);
      } catch {}
    });
  }

  private updateSplitMapLayers(): void {
    if (!this.splitMapControl) return;
    const ctl: any = this.splitMapControl as any;
    try {
      if (typeof ctl._updateLayers === 'function') ctl._updateLayers();
      if (typeof ctl._updateClip === 'function') ctl._updateClip();
      this.applyOverlayPaneClips();
    } catch (e) {
      console.warn('No se pudo actualizar capas del splitmap:', e);
    }
  }

  // ===== Clipping específico para panes de overlays (split-left / split-right)
  private bindSplitOverlayPaneClipping(): void {
    if (!this.myMap() || !this.splitMapControl || this._splitListenersBound)
      return;
    const map = this.myMap();
    const ctl = this.splitMapControl;

    try {
      this._onDividerMove = () => this.applyOverlayPaneClips();
      this._onMapMove = () => this.applyOverlayPaneClips();
      this._onMapZoom = () => this.applyOverlayPaneClips();
      this._onMapResize = () => this.applyOverlayPaneClips();

      ctl.on && ctl.on('dividermove', this._onDividerMove);
      map.on('move', this._onMapMove);
      map.on('zoom', this._onMapZoom);
      map.on('resize', this._onMapResize);
      this._splitListenersBound = true;
      // Primer clip inmediato
      this.applyOverlayPaneClips();

      // rAF polling por si el evento 'dividermove' no se emite en algunos navegadores
      const watch = () => {
        if (!this.myMap() || !this.splitMapControl) {
          this._clipWatcherRaf = null;
          return;
        }
        try {
          const mp = this.myMap();
          const ctlAny: any = this.splitMapControl as any;
          const pos =
            (typeof ctlAny.getPosition === 'function'
              ? ctlAny.getPosition()
              : mp?.getSize()?.x / 2) ?? 0;
          if (this._lastClipX !== pos) {
            this._lastClipX = pos;
            this.applyOverlayPaneClips();
          }
        } catch {}
        this._clipWatcherRaf = requestAnimationFrame(watch);
      };
      if (typeof window !== 'undefined') {
        this._clipWatcherRaf = requestAnimationFrame(watch);
      }
    } catch {}
  }

  private unbindSplitOverlayPaneClipping(): void {
    if (!this._splitListenersBound) return;
    const map = this.myMap();
    const ctl = this.splitMapControl;
    try {
      if (ctl && this._onDividerMove)
        ctl.off && ctl.off('dividermove', this._onDividerMove);
      if (map && this._onMapMove) map.off('move', this._onMapMove);
      if (map && this._onMapZoom) map.off('zoom', this._onMapZoom);
      if (map && this._onMapResize) map.off('resize', this._onMapResize);
    } catch {}
    // Limpiar clips
    try {
      this.setPaneClip('split-left', '');
      this.setPaneClip('split-right', '');
    } catch {}
    this._splitListenersBound = false;
    this._onDividerMove =
      this._onMapMove =
      this._onMapZoom =
      this._onMapResize =
        undefined as any;
    if (typeof window !== 'undefined' && this._clipRedrawRaf) {
      cancelAnimationFrame(this._clipRedrawRaf);
      this._clipRedrawRaf = null;
    }
    if (typeof window !== 'undefined' && this._clipWatcherRaf) {
      cancelAnimationFrame(this._clipWatcherRaf);
      this._clipWatcherRaf = null;
    }
    this._lastClipX = null;
    if (this._clipRedrawTimeout) {
      clearTimeout(this._clipRedrawTimeout);
      this._clipRedrawTimeout = null;
    }
  }

  private applyOverlayPaneClips(): void {
    const map = this.myMap();
    const ctl: any = this.splitMapControl as any;
    if (!map || !ctl) return;
    try {
      const nw = map.containerPointToLayerPoint([0, 0]);
      const se = map.containerPointToLayerPoint(map.getSize());
      const clipX =
        nw.x +
        (typeof ctl.getPosition === 'function'
          ? ctl.getPosition()
          : map.getSize().x / 2);
      const clipLeft = `rect(${nw.y}px, ${clipX}px, ${se.y}px, ${nw.x}px)`;
      const clipRight = `rect(${nw.y}px, ${se.x}px, ${se.y}px, ${clipX}px)`;
      this.setPaneClip('split-left', clipLeft);
      this.setPaneClip('split-right', clipRight);
    } catch {}
  }

  private setPaneClip(paneName: string, clip: string): void {
    try {
      const pane = this.myMap()?.getPane(paneName);
      if (pane && pane.style) pane.style.clip = clip;
    } catch {}
  }

  private installSplitUpdateLayersOverride(): void {
    const map = this.myMap();
    const ctl: any = this.splitMapControl as any;
    if (!map || !ctl) return;
    const splitLeft = map.getPane('split-left');
    const splitRight = map.getPane('split-right');

    if (this.imageBlur()) {
      this.processImageBlur(splitLeft, 'left');
      this.processImageBlur(splitRight, 'right');
    }

    // Override plugin method to categorize by pane instead of relying on its default behavior
    ctl._updateLayers = () => {
      const leftLayers: any[] = [];
      const rightLayers: any[] = [];
      try {
        map.eachLayer((ly: any) => {
          try {
            const pane = ly.getPane ? ly.getPane() : null;
            if (!pane) return;
            if (pane === splitLeft) leftLayers.push(ly);
            else if (pane === splitRight) rightLayers.push(ly);
          } catch {}
        });
      } catch {}
      if (this.leftBaseLayer && !leftLayers.includes(this.leftBaseLayer)) {
        leftLayers.unshift(this.leftBaseLayer);
      }
      if (this.rightBaseLayer && !rightLayers.includes(this.rightBaseLayer)) {
        rightLayers.unshift(this.rightBaseLayer);
      }
      ctl._leftLayers = leftLayers;
      ctl._rightLayers = rightLayers;
      if (typeof ctl._updateClip === 'function') ctl._updateClip();
    };
  }

  // ===== Overlay Global Loader =====
  private showGlobalLoader(): void {
    if (this.globalLoaderEl) return;
    try {
      const el = document.createElement('div');
      el.className = 'global-loader-overlay';
      el.innerHTML = `
        <div class="global-loader-spinner" role="status" aria-live="polite" aria-label="Cargando"></div>
      `;
      document.body.appendChild(el);
      this.globalLoaderEl = el;
      // Opcional: evitar scroll mientras carga
      document.body.classList.add('global-loader-active');
    } catch {}
  }

  private hideGlobalLoader(): void {
    if (!this.globalLoaderEl) {
      document.body.classList.remove('global-loader-active');
      return;
    }
    try {
      document.body.removeChild(this.globalLoaderEl);
    } catch {}
    this.globalLoaderEl = null;
    document.body.classList.remove('global-loader-active');
  }

  onDeleteSelectedArea(areaId: number) {
    console.log('🗑️ Eliminando área seleccionada con ID:', areaId);

    if (!areaId || areaId <= 0) {
      console.error('❌ ID de área inválido:', areaId);
      return;
    }

    // Cerrar el popup de información del área
    this.onCloseAreaInfo();

    // Limpiar overlays del área antes de eliminarla
    this.clearOverlaysForArea(areaId);

    // Eliminar el área usando el método existente
    this.deleteArea(areaId);
  }

  onImageBlurClick(event) {
    this.imageBlur.set(!this.imageBlur());
  }

  /**
   * Verifica si el índice en el lado especificado es VISIBLE (Imagen real)
   */
  private isIndexVisible(side: 'primary' | 'left' | 'right'): boolean {
    let form;
    if (side === 'primary') {
      form = this.primaryFilterFormGroup();
    } else if (side === 'left') {
      form = this.leftFilterFormGroup();
    } else {
      form = this.rightFilterFormGroup();
    }

    if (!form) return false;
    const indexValue = extractIndiceValue(form.value?.indice);
    return indexValue === 'VISIBLE';
  }

  processImageBlur(pane, side: 'primary' | 'left' | 'right' = 'primary') {
    if (!pane || !pane.style) return pane;

    // No aplicar blur si el índice en este lado es "Imagen real" (VISIBLE)
    if (this.isIndexVisible(side)) {
      pane.style.filter = '';
      pane.style.willChange = '';
      pane.style.imageRendering = '';
      return pane;
    }

    if (this.imageBlur()) {
      pane.style.filter = 'blur(4.5px)';
      pane.style.willChange = 'filter';
      pane.style.imageRendering = 'auto';
    } else {
      pane.style.filter = '';
      pane.style.willChange = '';
      pane.style.imageRendering = '';
    }
    return pane;
  }

  /**
   * Dibuja o elimina un borde negro alrededor del área seleccionada
   * cuando se está mostrando su índice (overlay activo).
   */
  private updateSelectedAreaBorder(): void {
    const map = this.myMap();
    if (!map) return;

    // Eliminar borde previo si existe
    try {
      if (this.areaBorderLayer && map.hasLayer(this.areaBorderLayer)) {
        map.removeLayer(this.areaBorderLayer);
      }
    } catch {}
    this.areaBorderLayer = null;

    const sel = this.selectedArea();
    if (!sel?.id) return;

    // ¿Se está mostrando el índice para el área seleccionada?
    const isComparison = this.showMenuComparacion();
    const isActive = isComparison
      ? this.overlaysBySide.left.has(sel.id) ||
        this.overlaysBySide.right.has(sel.id)
      : this.overlaysBySide.primary.has(sel.id);

    if (!isActive) return;

    // Obtener la geometría del área seleccionada
    const areaEntry = this.areaLayers.find(a => a.id === sel.id);
    if (!areaEntry) return;
    let feature: any;
    try {
      feature = areaEntry.layer?.toGeoJSON?.();
    } catch {}
    if (!feature) return;

    // Crear una capa GeoJSON sólo con trazo negro, sin relleno
    try {
      const layer = L.geoJSON(feature, {
        pane: this.AREA_BORDER_PANE,
        interactive: false,
        style: {
          color: '#000',
          weight: 4,
          opacity: 1,
          fill: false,
          fillOpacity: 0,
        },
      });
      layer.addTo(map);
      (layer as any).bringToFront?.();
      this.areaBorderLayer = layer;
    } catch {}
  }

  /**
   * Crea una máscara inversa que muestra en gris y deshabilitado todo el área fuera del geojson
   * @param geojsonData - Los datos del geojson que define el área permitida
   */
  private createAreaMask(geojsonData: any): void {
    const map = this.myMap();
    if (!map || !geojsonData) return;

    try {
      // Crear los límites del mundo para la máscara
      const worldBounds = [
        [
          [-90, -180],
          [-90, 180],
          [90, 180],
          [90, -180],
          [-90, -180],
        ],
      ];

      // Obtener las coordenadas del área permitida del geojson
      let areaHoles: number[][][] = [];

      if (geojsonData.type === 'FeatureCollection') {
        geojsonData.features.forEach((feature: any) => {
          if (feature.geometry && feature.geometry.coordinates) {
            if (feature.geometry.type === 'Polygon') {
              areaHoles.push(feature.geometry.coordinates[0]);
            } else if (feature.geometry.type === 'MultiPolygon') {
              feature.geometry.coordinates.forEach((polygon: any) => {
                areaHoles.push(polygon[0]);
              });
            }
          }
        });
      } else if (geojsonData.type === 'Feature') {
        if (geojsonData.geometry && geojsonData.geometry.coordinates) {
          if (geojsonData.geometry.type === 'Polygon') {
            areaHoles.push(geojsonData.geometry.coordinates[0]);
          } else if (geojsonData.geometry.type === 'MultiPolygon') {
            geojsonData.geometry.coordinates.forEach((polygon: any) => {
              areaHoles.push(polygon[0]);
            });
          }
        }
      } else if (geojsonData.type === 'Polygon') {
        areaHoles.push(geojsonData.coordinates[0]);
      } else if (geojsonData.type === 'MultiPolygon') {
        geojsonData.coordinates.forEach((polygon: any) => {
          areaHoles.push(polygon[0]);
        });
      }

      // Crear el polígono con agujeros (máscara inversa)
      const maskPolygon = {
        type: 'Polygon',
        coordinates: [worldBounds[0], ...areaHoles],
      };

      // Crear la capa GeoJSON para la máscara
      this.areaMaskLayer = L.geoJSON(maskPolygon, {
        style: {
          color: '#3f3f3fff',
          weight: 1,
          opacity: 0.3,
          fillColor: '#000000ff',
          fillOpacity: 0.6,
          interactive: false, // Deshabilitado para interacciones
        },
      });

      // Agregar la máscara al mapa con un zIndex bajo para que aparezca debajo
      this.areaMaskLayer.addTo(map);

      // Asegurar que la máscara esté por debajo de otras capas
      if (this.areaMaskLayer.getPane) {
        const pane = this.areaMaskLayer.getPane();
        if (pane) {
          pane.style.zIndex = '200'; // zIndex bajo para estar debajo
        }
      }

      // Hacer zoom al área permitida
      this.zoomToAllowedArea(geojsonData);

      console.log('✅ Máscara de área de trabajo aplicada');
    } catch (error) {
      console.error('❌ Error al crear máscara de área:', error);
    }
  }

  /**
   * Hace zoom al área permitida basándose en los datos del geojson
   * @param geojsonData - Los datos del geojson que define el área permitida
   */
  private zoomToAllowedArea(geojsonData: any): void {
    const map = this.myMap();
    if (!map || !geojsonData) return;

    try {
      // Crear una capa temporal para calcular los límites
      const tempLayer = L.geoJSON(geojsonData);
      const bounds = tempLayer.getBounds();

      // Si hay límites válidos, hacer zoom con padding
      if (bounds.isValid()) {
        map.fitBounds(bounds, {
          padding: [20, 20], // Padding de 20px en todos los lados
          maxZoom: 16, // Limitar el zoom máximo para evitar acercarse demasiado
        });
      }

      console.log('✅ Zoom aplicado al área permitida');
    } catch (error) {
      console.error('❌ Error al hacer zoom al área:', error);
    }
  }

  initUserSettings(): void {
    this.configuracionService
      .getCompany(this.companyId())
      .pipe(
        tap((data: any) => {
          this.companyData.set(data);

          // Lógica de centrado para usuarios SAAS (company_id = 1) si no hay áreas
          if (
            this.companyId() === 1 &&
            this.areaLayers.length === 0 &&
            data.geojson
          ) {
            setTimeout(() => {
              const map = this.myMap();
              if (map) {
                map.invalidateSize();
                const layer = L.geoJSON(data.geojson);
                const bounds = layer.getBounds();
                if (bounds.isValid()) {
                  map.fitBounds(bounds, { padding: [50, 50], maxZoom: 16 });
                }
              }
            }, 200);
          }
        })
      )
      .subscribe();
  }
}
